function initLazyScript(e, t, i = 500) {
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(
      (e, i) => {
        e.forEach((e) => {
          e.isIntersecting &&
            "function" == typeof t &&
            (t(), i.unobserve(e.target));
        });
      },
      { rootMargin: `0px 0px ${i}px 0px` }
    ).observe(e);
  } else t();
}
function debounce(e, t = 300) {
  let i;
  return (...n) => {
    clearTimeout(i), (i = setTimeout(() => e.apply(this, n), t));
  };
}
let lastViewportHeight = 0;
function setViewportHeight() {
  const vh = window.innerHeight;
  if (vh === lastViewportHeight) return; // Skip if unchanged
  lastViewportHeight = vh;

  requestAnimationFrame(() => {
    document.documentElement.style.setProperty("--viewport-height", `${vh}px`);
  });
}
let lastHeaderHeight = 0;
let lastAnnouncementHeight = 0;

function setHeaderHeight() {
  const header = document.querySelector(".js-header-height");
  if (!header) return;

  const announcement = document.querySelector(".cc-announcement");
  const announcementHeight = announcement ? announcement.offsetHeight : 0;

  const totalHeight = header.offsetHeight + announcementHeight;

  // Skip if heights haven't changed
  if (totalHeight === lastHeaderHeight && announcementHeight === lastAnnouncementHeight) return;

  lastHeaderHeight = totalHeight;
  lastAnnouncementHeight = announcementHeight;

  requestAnimationFrame(() => {
    document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
    document.documentElement.style.setProperty("--header-height", `${totalHeight}px`);
  });
}
let lastScrollbarWidth = 0;

function setScrollbarWidth() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  if (scrollbarWidth === lastScrollbarWidth) return; // Skip if unchanged
  lastScrollbarWidth = scrollbarWidth;

  requestAnimationFrame(() => {
    document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarWidth}px`);
  });
}
function setDimensionVariables() {
  setViewportHeight(), setHeaderHeight(), setScrollbarWidth();
}
function pauseAllMedia(e = document) {
  e.querySelectorAll(".js-youtube, .js-vimeo, video").forEach((e) => {
    const t = e.closest("video-component");
    (t && "true" === t.dataset.background) ||
      (e.matches(".js-youtube")
        ? e.contentWindow.postMessage(
            '{ "event": "command", "func": "pauseVideo", "args": "" }',
            "*"
          )
        : e.matches(".js-vimeo")
        ? e.contentWindow.postMessage('{ "method": "pause" }', "*")
        : e.pause());
  }),
    e.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
(theme.stickyHeaderHeight = () => {
  const e = getComputedStyle(document.documentElement).getPropertyValue(
    "--theme-sticky-header-height"
  );
  return (e && parseInt(e, 10)) || 0;
}),
  (theme.getOffsetTopFromDoc = (e) =>
    e.getBoundingClientRect().top + window.scrollY),
  (theme.getOffsetLeftFromDoc = (e) =>
    e.getBoundingClientRect().left + window.scrollX),
  (theme.getScrollParent = (e) => {
    const t = e instanceof HTMLElement && window.getComputedStyle(e).overflowY;
    return e
      ? "visible" !== t && "hidden" !== t && e.scrollHeight > e.clientHeight
        ? e
        : theme.getScrollParent(e.parentNode) ||
          document.scrollingElement ||
          window
      : null;
  }),
  (theme.scrollToRevealElement = (e) => {
    const t = theme.getScrollParent(e),
      i = t === window ? window.scrollY : t.scrollTop,
      n = t === window ? window.innerHeight : t.clientHeight,
      s = theme.getOffsetTopFromDoc(e),
      r = s + e.offsetHeight;
    (s < i + theme.stickyHeaderHeight() || r > i + n - 50) &&
      t.scrollTo({
        top: s - 100 - theme.stickyHeaderHeight(),
        left: 0,
        behavior: "smooth",
      });
  }),
  (theme.getEmptyOptionSelectors = (e) => {
    const t = [];
    return (
      e
        .querySelectorAll('[data-selector-type="dropdown"].option-selector')
        .forEach((e) => {
          e.querySelector(
            '[aria-selected="true"][data-value]:not([data-value=""])'
          ) || t.push(e);
        }),
      e
        .querySelectorAll('[data-selector-type="listed"].option-selector')
        .forEach((e) => {
          e.querySelector("input:checked") || t.push(e);
        }),
      t
    );
  }),
  (theme.suffixIds = (e, t) => {
    const i = ["id", "for", "aria-describedby", "aria-controls"];
    for (let n = 0; n < i.length; n += 1)
      e.querySelectorAll(`[${i[n]}]`).forEach((e) =>
        e.setAttribute(i[n], e.getAttribute(i[n]) + t)
      );
  }),
  (theme.addDelegateEventListener = (e, t, i, n, s = null) => {
    const r = (t) => {
      const s = t.target.closest(i);
      s && e.contains(s) && n.call(s, t, s);
    };
    return e.addEventListener(t, r, s), r;
  }),
  (theme.hideAndRemove = (e) => {
    e.querySelectorAll("input").forEach((e) => {
      e.disabled = !0;
    });
    const t = document.createElement("div");
    (t.className = "merge-remove-wrapper"),
      e.parentNode.insertBefore(t, e),
      t.appendChild(e),
      e.classList.add("merge-remove-item"),
      (t.style.height = `${t.clientHeight}px`);
    const i = getComputedStyle(e),
      n = 1e3 * parseFloat(i.getPropertyValue("--fade-duration")),
      s = 1e3 * parseFloat(i.getPropertyValue("--slide-duration"));
    setTimeout(() => {
      t.classList.add("merge-remove-wrapper--fade"),
        setTimeout(() => {
          t.classList.add("merge-remove-wrapper--slide"),
            setTimeout(() => t.remove(), s);
        }, n);
    }, 10);
  }),
  (theme.insertAndReveal = (e, t, i, n) => {
    const s = n || 10;
    e.classList.add("merge-add-wrapper"),
      t.insertAdjacentElement(i, e),
      (e.style.height = `${e.firstElementChild.clientHeight}px`);
    const r = getComputedStyle(e),
      o = 1e3 * parseFloat(r.getPropertyValue("--fade-duration")),
      a = 1e3 * parseFloat(r.getPropertyValue("--slide-duration"));
    setTimeout(() => {
      e.classList.add("merge-add-wrapper--slide"),
        setTimeout(() => {
          e.classList.add("merge-add-wrapper--fade"),
            setTimeout(() => {
              (e.style.height = ""),
                e.classList.remove(
                  "merge-add-wrapper",
                  "merge-add-wrapper--slide",
                  "merge-add-wrapper--fade"
                );
            }, o);
        }, a);
    }, s);
  }),
  (theme.mergeNodes = (e, t) => {
    try {
      e.querySelectorAll("[data-merge]").forEach((e) => {
        const i = t.querySelector(`[data-merge="${e.dataset.merge}"]`);
        (e.dataset.mergeCache &&
          i.dataset.mergeCache &&
          e.dataset.mergeCache === i.dataset.mergeCache) ||
          ((i.innerHTML = e.innerHTML),
          (e.dataset.mergeCache || i.dataset.mergeCache) &&
            (i.dataset.mergeCache = e.dataset.mergeCache));
      }),
        e.querySelectorAll("[data-merge-attributes]").forEach((e) => {
          const i = t.querySelector(
              `[data-merge-attributes="${e.dataset.mergeAttributes}"]`
            ),
            n = e.getAttributeNames();
          for (let t = 0; t < n.length; t += 1) {
            const s = n[t];
            i.setAttribute(s, e.getAttribute(s));
          }
        }),
        e.querySelectorAll("[data-merge-list]").forEach((e) => {
          const i = t.querySelector(
            `[data-merge-list="${e.dataset.mergeList}"]`
          );
          let n = Array.from(i.querySelectorAll("[data-merge-list-item]"));
          const s = Array.from(e.querySelectorAll("[data-merge-list-item]"));
          n.forEach((e) => {
            s.find(
              (t) => t.dataset.mergeListItem === e.dataset.mergeListItem
            ) || theme.hideAndRemove(e);
          }),
            (n = Array.from(
              i.querySelectorAll(
                "[data-merge-list-item]:not(.merge-remove-item)"
              )
            ));
          for (let e = 0; e < s.length; e += 1) {
            const t = s[e],
              r = n.find(
                (e) => e.dataset.mergeListItem === t.dataset.mergeListItem
              );
            r
              ? (t.dataset.mergeCache &&
                  r.dataset.mergeCache &&
                  t.dataset.mergeCache === r.dataset.mergeCache) ||
                ((r.innerHTML = t.innerHTML),
                t.dataset.mergeCache &&
                  (r.dataset.mergeCache = t.dataset.mergeCache))
              : (0 === e
                  ? theme.insertAndReveal(t, i, "afterbegin", 500)
                  : e >= n.length
                  ? theme.insertAndReveal(t, i, "beforeend", 500)
                  : theme.insertAndReveal(t, n[e], "beforebegin", 500),
                n.splice(e, 0, t));
          }
        });
    } catch (e) {
      window.location.reload();
    }
  }),
  (theme.showQuickPopup = (e, t) => {
    const i = theme.getOffsetLeftFromDoc(t),
      n = theme.getOffsetTopFromDoc(t),
      s = t.getBoundingClientRect().left,
      r = document.createElement("div");
    (r.className = "simple-popup simple-popup--hidden"),
      (r.innerHTML = e),
      (r.style.left = `${i}px`),
      (r.style.top = `${n}px`),
      document.body.appendChild(r);
    let o = -(r.clientWidth - t.clientWidth) / 2;
    s + o < 0 && (o -= s + o - 2);
    const a = i + o + r.clientWidth + 5;
    a > window.innerWidth && (o -= a - window.innerWidth),
      (r.style.marginTop = -r.clientHeight - 10),
      (r.style.marginLeft = o),
      setTimeout(() => {
        r.classList.remove("simple-popup--hidden");
      }, 10),
      setTimeout(() => {
        r.classList.add("simple-popup--hidden");
      }, 3500),
      setTimeout(() => {
        r.remove();
      }, 4e3);
  }),
  (theme.manuallyLoadImages = (e) => {
    e.querySelectorAll("img[data-manual-src]").forEach((e) => {
      (e.src = e.dataset.manualSrc),
        e.removeAttribute("data-manual-src"),
        e.dataset.manualSrcset &&
          ((e.srcset = e.dataset.manualSrcset),
          e.removeAttribute("data-manual-srcset"));
    });
  }),
  (theme.whenComponentLoaded = (e, t) => {
    const i = Symbol.iterator in Object(e) ? [...e] : [e];
    if (!i.find((e) => !e.hasAttribute("loaded"))) return void t();
    const n = new MutationObserver((e, n) => {
      for (let s = 0; s < e.length; s += 1) {
        "attributes" === e[s].type &&
          (i.find((e) => !e.hasAttribute("loaded")) ||
            (n.disconnect(), t.call()));
      }
    });
    i.forEach((e) =>
      n.observe(e, { attributes: !0, attributeFilter: ["loaded"] })
    );
  }),
  window.addEventListener(
    "resize",
    debounce(() => {
      window.dispatchEvent(new CustomEvent("on:debounced-resize"));
    })
  ),
  (() => {
    const { mediaQueries: e } = theme;
    if (!e) return;
    const t = Object.keys(e),
      i = {};
    theme.mediaMatches = {};
    const n = () => {
      const e = t.reduce((e, t) => ((e[t] = !(!i[t] || !i[t].matches)), e), {});
      Object.keys(e).forEach((t) => {
        theme.mediaMatches[t] = e[t];
      }),
        window.dispatchEvent(new CustomEvent("on:breakpoint-change"));
    };
    t.forEach((t) => {
      (i[t] = window.matchMedia(e[t])), (theme.mediaMatches[t] = i[t].matches);
      try {
        i[t].addEventListener("change", n);
      } catch (e) {
        i[t].addListener(n);
      }
    });
  })(),
  document.addEventListener("DOMContentLoaded", setDimensionVariables),
  window.addEventListener("resize", debounce(setDimensionVariables, 400)),
  setTimeout(setViewportHeight, 3e3);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector(".js-load-media");
    e
      ? e.addEventListener("click", this.loadContent.bind(this))
      : this.addObserver();
  }
  addObserver() {
    if ("IntersectionObserver" in window == !1) return;
    const e = new IntersectionObserver(
      (t) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (this.loadContent(!1, !1, "observer"), e.unobserve(this));
        });
      },
      { rootMargin: "0px 0px 1000px 0px" }
    );
    e.observe(this);
  }
  loadContent(e = !0, t = !0, i = "click") {
    if ((t && pauseAllMedia(), null !== this.getAttribute("loaded"))) return;
    this.loadTrigger = i;
    const n = this.querySelector(
      "template"
    ).content.firstElementChild.cloneNode(!0);
    this.appendChild(n), this.setAttribute("loaded", "");
    const s = this.querySelector("video, model-viewer, iframe");
    s && e && s.focus();
  }
}
customElements.define("deferred-media", DeferredMedia);
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super(),
      (this.disclosure = this.querySelector("details")),
      (this.toggle = this.querySelector("summary")),
      (this.panel = this.toggle.nextElementSibling),
      this.init();
  }
  init() {
    window.getComputedStyle(this.panel).transitionDuration;
  }
  handleToggle(e) {
    e.preventDefault(), this.disclosure.open ? this.close() : this.open();
  }
  handleTransitionEnd(e) {
    e.target === this.panel &&
      (this.disclosure.classList.contains("is-closing") &&
        (this.disclosure.classList.remove("is-closing"),
        (this.disclosure.open = !1)),
      this.panel.removeAttribute("style"));
  }
  addContentHeight() {
    this.panel.style.height = `${this.panel.scrollHeight}px`;
  }
  open() {
    (this.panel.style.height = "0"),
      (this.disclosure.open = !0),
      this.addContentHeight();
  }
  close() {
    this.addContentHeight(),
      this.disclosure.classList.add("is-closing"),
      setTimeout(() => {
        this.panel.style.height = "0";
      });
  }
}
if (
  (customElements.define("details-disclosure", DetailsDisclosure),
  !customElements.get("gift-card-recipient"))
) {
  class e extends HTMLElement {
    connectedCallback() {
      (this.recipientEmail = this.querySelector(
        '[name="properties[Recipient email]"]'
      )),
        (this.recipientEmailLabel = this.querySelector(
          `label[for="${this.recipientEmail.id}"]`
        )),
        (this.recipientName = this.querySelector(
          '[name="properties[Recipient name]"]'
        )),
        (this.recipientMessage = this.querySelector(
          '[name="properties[Message]"]'
        )),
        (this.recipientSendOn = this.querySelector(
          '[name="properties[Send on]"]'
        )),
        (this.recipientOffsetProperty = this.querySelector(
          '[name="properties[__shopify_offset]"]'
        )),
        this.recipientEmailLabel &&
          this.recipientEmailLabel.dataset.jsLabel &&
          (this.recipientEmailLabel.innerText =
            this.recipientEmailLabel.dataset.jsLabel),
        this.recipientOffsetProperty &&
          ((this.recipientOffsetProperty.value = new Date()
            .getTimezoneOffset()
            .toString()),
          this.recipientOffsetProperty.removeAttribute("disabled")),
        (this.recipientCheckbox = this.querySelector(
          ".gift-card-recipient__checkbox"
        )),
        this.recipientCheckbox.addEventListener("change", () =>
          this.synchronizeProperties()
        ),
        this.synchronizeProperties();
    }
    synchronizeProperties() {
      this.recipientCheckbox.checked
        ? (this.recipientEmail.setAttribute("required", ""),
          this.recipientEmail.removeAttribute("disabled"),
          this.recipientName.removeAttribute("disabled"),
          this.recipientMessage.removeAttribute("disabled"),
          this.recipientSendOn.removeAttribute("disabled"),
          this.recipientOffsetProperty &&
            this.recipientOffsetProperty.removeAttribute("disabled"))
        : (this.recipientEmail.removeAttribute("required"),
          this.recipientEmail.setAttribute("disabled", ""),
          this.recipientName.setAttribute("disabled", ""),
          this.recipientMessage.setAttribute("disabled", ""),
          this.recipientSendOn.setAttribute("disabled", ""),
          this.recipientOffsetProperty &&
            this.recipientOffsetProperty.setAttribute("disabled", ""));
    }
  }
  customElements.define("gift-card-recipient", e);
}
const trapFocusHandlers = {};
function removeTrapFocus(e = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown),
    e && e.focus();
}
function trapFocus(e, t = e) {
  const i = Array.from(
    e.querySelectorAll(
      'summary, a[href], area[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), object, iframe, audio[controls], video[controls], [tabindex]:not([tabindex^="-"])'
    )
  );
  let n = null,
    s = null;
  const r = (e) =>
      e.offsetParent && "hidden" !== getComputedStyle(e).visibility,
    o = () => {
      for (let e = 0; e < i.length; e += 1)
        if (r(i[e])) {
          n = i[e];
          break;
        }
      for (let e = i.length - 1; e >= 0; e -= 1)
        if (r(i[e])) {
          s = i[e];
          break;
        }
    };
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (t) => {
      o(),
        (t.target !== e && t.target !== s && t.target !== n) ||
          document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = () => {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = (t) => {
      "Tab" === t.code &&
        (o(),
        t.target !== s || t.shiftKey || (t.preventDefault(), n.focus()),
        (t.target !== e && t.target !== n) ||
          !t.shiftKey ||
          (t.preventDefault(), s.focus()));
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    (t || e).focus();
}
class Modal extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", this.handleClick.bind(this));
  }
  handleClick(e) {
    (e.target === this || e.target.matches(".js-close-modal")) && this.close();
  }
  open(e) {
    this.setAttribute("open", ""),
      (this.openedBy = e),
      trapFocus(this),
      window.pauseAllMedia(),
      (this.keyupHandler = (e) => "Escape" === e.key && this.close()),
      this.addEventListener("keyup", this.keyupHandler),
      this.querySelectorAll("table").forEach((e) => {
        const t = document.createElement("div");
        (t.className = "scrollable-table"),
          e.parentNode.insertBefore(t, e),
          t.appendChild(e);
      });
  }
  close() {
    this.removeAttribute("open"),
      removeTrapFocus(this.openedBy),
      window.pauseAllMedia(),
      this.removeEventListener("keyup", this.keyupHandler);
  }
}
customElements.define("modal-dialog", Modal);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector("button");
    e &&
      e.addEventListener("click", () => {
        const t = document.getElementById(this.dataset.modal);
        t && t.open(e);
      });
  }
}
customElements.define("modal-opener", ModalOpener);
class SideDrawer extends HTMLElement {
  constructor() {
    super(), (this.overlay = document.querySelector(".js-overlay"));
  }
  handleClick(e) {
    (e.target.matches(".js-close-drawer") || e.target === this.overlay) &&
      this.close();
  }
  open(e, t, i) {
    this.dispatchEvent(
      new CustomEvent(`on:${this.dataset.name}:before-open`, { bubbles: !0 })
    ),
      this.overlay.classList.add("is-visible"),
      this.setAttribute("open", ""),
      this.setAttribute("aria-hidden", "false"),
      (this.opener = e),
      trapFocus(this, t),
      (this.clickHandler = this.clickHandler || this.handleClick.bind(this)),
      (this.keyupHandler = (e) => {
        "Escape" !== e.key ||
          e.target.closest(".cart-drawer-popup") ||
          this.close();
      }),
      this.addEventListener("click", this.clickHandler),
      this.addEventListener("keyup", this.keyupHandler),
      this.overlay.addEventListener("click", this.clickHandler);
    const n = parseFloat(
      getComputedStyle(this).getPropertyValue("--longest-transition-in-ms")
    );
    setTimeout(() => {
      i && i(),
        this.dispatchEvent(
          new CustomEvent(`on:${this.dataset.name}:after-open`, { bubbles: !0 })
        );
    }, n);
  }
  close(e) {
    this.dispatchEvent(
      new CustomEvent(`on:${this.dataset.name}:before-close`, { bubbles: !0 })
    ),
      this.removeAttribute("open"),
      this.setAttribute("aria-hidden", "true"),
      this.overlay.classList.remove("is-visible"),
      removeTrapFocus(this.opener),
      this.removeEventListener("click", this.clickHandler),
      this.removeEventListener("keyup", this.keyupHandler),
      this.overlay.removeEventListener("click", this.clickHandler);
    const t = parseFloat(
      getComputedStyle(this).getPropertyValue("--longest-transition-in-ms")
    );
    setTimeout(() => {
      e && e(),
        this.dispatchEvent(
          new CustomEvent(`on:${this.dataset.name}:after-close`, {
            bubbles: !0,
          })
        );
    }, t);
  }
}
customElements.define("side-drawer", SideDrawer);
class BuyButtons extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.initLazySection.bind(this));
  }
  initLazySection() {
    (this.dynamicPaymentButtonTemplate = this.querySelector(
      ".dynamic-payment-button-template"
    )),
      this.dynamicPaymentButtonTemplate &&
        ((this.variantIdInput = this.querySelector('[name="id"]')),
        this.variantIdInput.value
          ? this.tryInitDynamicPaymentButton()
          : ((this.boundTryInitDynamicPaymentButtonOnChange =
              this.tryInitDynamicPaymentButton.bind(this)),
            this.variantIdInput.addEventListener(
              "change",
              this.boundTryInitDynamicPaymentButtonOnChange
            )));
  }
  tryInitDynamicPaymentButton() {
    this.variantIdInput.value &&
      (this.boundTryInitDynamicPaymentButtonOnChange &&
        this.variantIdInput.removeEventListener(
          "change",
          this.boundTryInitDynamicPaymentButtonOnChange
        ),
      this.dynamicPaymentButtonTemplate.insertAdjacentHTML(
        "afterend",
        this.dynamicPaymentButtonTemplate.innerHTML
      ),
      this.dynamicPaymentButtonTemplate.remove(),
      Shopify.PaymentButton && Shopify.PaymentButton.init());
  }
}
customElements.define("buy-buttons", BuyButtons);
const CartForm = class extends HTMLElement {
  connectedCallback() {
    (this.enableAjaxUpdate = this.dataset.ajaxUpdate),
      this.enableAjaxUpdate &&
        ((this.sectionId = this.dataset.sectionId),
        (this.boundRefresh = this.refresh.bind(this)),
        document.addEventListener("on:cart:change", this.boundRefresh),
        this.addEventListener("submit", (e) => {
          const t = document.activeElement;
          if (t && t.classList.contains("cart-item__quantity-input")) {
            const i = t.closest(".cart-item");
            i &&
              (e.preventDefault(),
              this.adjustItemQuantity(i, { currentValue: !0 }));
          }
        }),
        theme.addDelegateEventListener(
          this,
          "click",
          ".cart-item__remove",
          (e) => {
            e.preventDefault(),
              this.adjustItemQuantity(e.target.closest(".cart-item"), {
                to: 0,
              });
          }
        ),
        theme.addDelegateEventListener(this, "click", ".quantity-down", (e) => {
          e.preventDefault(),
            this.adjustItemQuantity(e.target.closest(".cart-item"), {
              decrease: !0,
            });
        }),
        theme.addDelegateEventListener(this, "click", ".quantity-up", (e) => {
          e.preventDefault(),
            this.adjustItemQuantity(e.target.closest(".cart-item"), {
              increase: !0,
            });
        }),
        theme.addDelegateEventListener(
          this,
          "change",
          ".cart-item__quantity-input",
          (e) => {
            this.adjustItemQuantity(e.target.closest(".cart-item"), {
              currentValue: !0,
            });
          }
        ));
  }
  disconnectedCallback() {
    this.enableAjaxUpdate &&
      document.removeEventListener("on:cart:change", this.boundRefresh);
  }
  refresh() {
    this.classList.add("cart-form--refreshing"),
      fetch(`${window.Shopify.routes.root}?section_id=${this.sectionId}`)
        .then((e) => {
          if (!e.ok) throw new Error(`HTTP error! Status: ${e.status}`);
          return e.text();
        })
        .then((e) => {
          this.refreshFromHtml(e);
        });
  }
  refreshFromHtml(e) {
    const t = document.createDocumentFragment(),
      i = document.createElement("div");
    t.appendChild(i),
      (i.innerHTML = e),
      i
        .querySelectorAll("[data-cc-animate]")
        .forEach((e) => e.removeAttribute("data-cc-animate")),
      theme.mergeNodes(i, this),
      this.classList.remove("cart-form--refreshing"),
      this.querySelectorAll(".merge-item-refreshing").forEach((e) =>
        e.classList.remove("merge-item-refreshing")
      ),
      this.dispatchEvent(
        new CustomEvent("on:cart:after-merge", { bubbles: !0, cancelable: !1 })
      ),
      typeof _swat !== "undefined" && _swat?.initializeActionButtons("cart-form"),
      "drawer" === theme.settings.afterAddToCart &&
        this.closest(".drawer") &&
        !this.closest(".drawer").hasAttribute("open") &&
        document.dispatchEvent(
          new CustomEvent("theme:open-cart-drawer", {
            bubbles: !0,
            cancelable: !1,
          })
        );
  }
  adjustItemQuantity(e, t) {
    const i = e.querySelector(".cart-item__quantity-input");
    let n = parseInt(i.value, 10);
    void 0 !== t.to
      ? ((n = t.to), (i.value = n))
      : t.increase
      ? ((n += i.step || 1), (i.value = n))
      : t.decrease
      ? ((n -= i.step || 1), (i.value = n))
      : t.currentValue,
      i.max &&
        parseInt(i.value, 10) > parseInt(i.max, 10) &&
        ((n = i.max), (i.value = n)),
      i &&
        0 === n &&
        window.removeItemNotification(i.dataset.id, i.dataset.quantity),
      clearTimeout(this.adjustItemQuantityTimeout),
      (this.adjustItemQuantityTimeout = setTimeout(
        () => {
          const e = { updates: {} };
          this.querySelectorAll(
            ".cart-item__quantity-input:not([disabled])"
          ).forEach((t) => {
            (e.updates[t.dataset.key] = t.value),
              t.value !== t.dataset.initialValue &&
                t
                  .closest("[data-merge-list-item]")
                  .classList.add("merge-item-refreshing");
          }),
            fetch(theme.routes.cartUpdate, {
              method: "POST",
              body: JSON.stringify(e),
              headers: { "Content-Type": "application/json" },
            })
              .then((e) => {
                if (!e.ok) throw new Error(`HTTP error! Status: ${e.status}`);
                document.dispatchEvent(
                  new CustomEvent("on:cart:change", {
                    bubbles: !0,
                    cancelable: !1,
                  })
                );
              })
              .catch((e) => {
                console.log(e.message),
                  this.dispatchEvent(
                    new CustomEvent("on:cart:error", {
                      bubbles: !0,
                      detail: { error: e.message },
                    })
                  ),
                  window.location.reload();
              });
        },
        0 === n ? 10 : 700
      ));
  }
};
window.customElements.define("cart-form", CartForm);
const CCCartCrossSell = class extends HTMLElement {
  init() {
    (this.productList = this.querySelector(".product-grid")),
      this.dataset.from &&
        fetch(this.dataset.from)
          .then((e) => {
            if (!e.ok) throw new Error(`HTTP error! Status: ${e.status}`);
            return e.text();
          })
          .then((e) => {
            const t = document.createDocumentFragment(),
              i = document.createElement("div");
            t.appendChild(i), (i.innerHTML = e);
            const n = i.querySelector(".product-grid");
            n
              ? ((this.productList.innerHTML = n.innerHTML),
                this.querySelectorAll("carousel-slider").forEach((e) =>
                  e.refresh()
                ))
              : this.classList.add("hidden");
          });
  }
};
window.customElements.define("cc-cart-cross-sell", CCCartCrossSell);
const CCFetchedContent = class extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url)
      .then((e) => {
        if (!e.ok) throw new Error(`HTTP error! Status: ${e.status}`);
        return e.text();
      })
      .then((e) => {
        const t = document.createDocumentFragment(),
          i = document.createElement("div");
        t.appendChild(i), (i.innerHTML = e);
        const n = i.querySelector(`[data-id="${this.dataset.id}"]`);
        n && (this.innerHTML = n.innerHTML);
      });
  }
};
function throttle(e, t = 300) {
  let i = -1,
    n = !1;
  return () => {
    clearTimeout(i),
      (i = setTimeout(e, t)),
      n ||
        (e.call(),
        (n = !0),
        setTimeout(() => {
          n = !1;
        }, t));
  };
}
window.customElements.define("cc-fetched-content", CCFetchedContent);
const GalleryViewer = class extends HTMLElement {
  connectedCallback() {
    this.initialised ||
      ((this.initialised = !0),
      this.classList.add("gallery-viewer--pre-reveal"),
      (this.zoomContainer = this.querySelector(
        ".gallery-viewer__zoom-container"
      )),
      (this.thumbContainer = this.querySelector(".gallery-viewer__thumbs")),
      (this.controlsContainer = this.querySelector(
        ".gallery-viewer__controls"
      )),
      (this.previousBtn = this.querySelector(".gallery-viewer__prev")),
      (this.nextBtn = this.querySelector(".gallery-viewer__next")),
      (this.wheelZoomMultiplier = -0.001),
      (this.pinchZoomMultiplier = 0.003),
      (this.touchPanModifier = 1),
      (this.currentZoomImage = null),
      (this.currentTransform = { panX: 0, panY: 0, zoom: 0.5 }),
      (this.pinchTracking = { isTracking: !1, lastPinchDistance: 0 }),
      (this.touchTracking = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 }),
      theme.addDelegateEventListener(
        this,
        "click",
        ".gallery-viewer__thumb",
        this.onThumbClick.bind(this)
      ),
      this.thumbContainer.addEventListener("touchmove", (e) =>
        e.stopPropagation()
      ),
      this.previousBtn.addEventListener(
        "click",
        this.selectPreviousThumb.bind(this)
      ),
      this.nextBtn.addEventListener("click", this.selectNextThumb.bind(this)),
      this.zoomContainer.addEventListener(
        "click",
        this.onZoomContainerClick.bind(this)
      ),
      new ResizeObserver(() => this.setInitialImagePosition()).observe(this)),
      document.documentElement.classList.add("gallery-viewer-open"),
      this.addEventListener("keyup", this.handleKeyup.bind(this)),
      setTimeout(() => this.classList.remove("gallery-viewer--pre-reveal"), 10);
  }
  disconnectedCallback() {
    document.documentElement.classList.remove("gallery-viewer-open");
  }
  static createEl(e, t, i, n) {
    const s = document.createElement(e);
    return (
      (s.className = t),
      "a" === e && (s.href = "#"),
      i && i.insertAdjacentElement("beforeend", s),
      n && (s.innerHTML = n),
      s
    );
  }
  init(e) {
    this.selectThumb(
      [...this.thumbContainer.children].find((t) => t.dataset.zoomUrl === e) ||
        this.thumbContainer.firstElementChild
    );
  }
  panZoomImageFromCoordinate(e, t) {
    const i = this.currentZoomImage.clientWidth > this.clientWidth,
      n = this.currentZoomImage.clientHeight > this.clientHeight;
    if (i || n) {
      const s = this.clientWidth / 2,
        r = this.clientHeight / 2,
        o = e - s,
        a = t - r;
      let l = 0,
        c = 0;
      if (i) {
        const e =
          (this.currentZoomImage.clientWidth - this.clientWidth) / 2 / s;
        l = Math.round(-o * e);
      }
      if (n) {
        const e =
          (this.currentZoomImage.clientHeight - this.clientHeight) / 2 / r;
        c = Math.round(-a * e);
      }
      (this.currentTransform.panX = l),
        (this.currentTransform.panY = c),
        this.alterCurrentPanBy(0, 0),
        this.updateImagePosition();
    }
  }
  alterCurrentPanBy(e, t) {
    this.currentTransform.panX += e;
    let i =
      (this.currentZoomImage.naturalWidth * this.currentTransform.zoom -
        this.clientWidth) /
      2;
    (i = Math.max(i, 0)),
      (this.currentTransform.panX = Math.min(this.currentTransform.panX, i)),
      (this.currentTransform.panX = Math.max(this.currentTransform.panX, -i)),
      (this.currentTransform.panY += t);
    let n =
      (this.currentZoomImage.naturalHeight * this.currentTransform.zoom -
        this.clientHeight) /
      2;
    (n = Math.max(n, 0)),
      (this.currentTransform.panY = Math.min(this.currentTransform.panY, n)),
      (this.currentTransform.panY = Math.max(this.currentTransform.panY, -n)),
      this.updateImagePosition();
  }
  setCurrentTransform(e, t, i) {
    (this.currentTransform.panX = e),
      (this.currentTransform.panY = t),
      (this.currentTransform.zoom = i),
      this.alterCurrentTransformZoomBy(0);
  }
  alterCurrentTransformZoomBy(e) {
    this.currentTransform.zoom += e;
    const t = this.clientWidth / this.currentZoomImage.naturalWidth,
      i = (this.clientHeight / this.currentZoomImage.naturalHeight) * 0.5;
    (this.currentTransform.zoom = Math.max(this.currentTransform.zoom, 1)),
      (this.currentTransform.zoom = Math.min(this.currentTransform.zoom, 1.5)),
      this.alterCurrentPanBy(0, 0);
    const epsilon = 1e-4;
    if (this.currentZoomImage) {
      this.currentZoomImage.style.cursor =
        this.currentTransform.zoom > 1 + epsilon ? "zoom-out" : "zoom-in";
    }
    this.updateImagePosition();
  }
  setInitialImagePosition() {
    (this.currentZoomImage.style.top =
      this.clientHeight / 2 - this.currentZoomImage.clientHeight / 2 + "px"),
      (this.currentZoomImage.style.left =
        this.clientWidth / 2 - this.currentZoomImage.clientWidth / 2 + "px"),
      this.setCurrentTransform(0, 0, 1),
      this.classList.toggle(
        "gallery-viewer--zoomable",
        this.currentZoomImage.naturalWidth > this.clientWidth / 2 ||
          this.currentZoomImage.naturalHeight > this.clientHeight / 2
      );
  }
  updateImagePosition() {
    this.currentZoomImage.style.transform = `translate3d(${this.currentTransform.panX}px, ${this.currentTransform.panY}px, 0) scale(${this.currentTransform.zoom})`;
  }
  selectThumb(e) {
    [...e.parentElement.children].forEach((t) => {
      t === e
        ? t.classList.add("gallery-viewer__thumb--active")
        : t.classList.remove("gallery-viewer__thumb--active");
    }),
      this.zoomContainer.classList.add(
        "gallery-viewer__zoom-container--loading"
      ),
      (this.currentZoomImage = GalleryViewer.createEl(
        "img",
        "gallery-viewer__zoom-image"
      )),
      (this.currentZoomImage.alt = ""),
      (this.currentZoomImage.style.visibility = "hidden"),
      (this.currentZoomImage.onload = () => {
        this.zoomContainer.classList.remove(
          "gallery-viewer__zoom-container--loading"
        ),
          (this.currentZoomImage.style.visibility = ""),
          this.setInitialImagePosition();
      }),
      (this.currentZoomImage.src = e.dataset.zoomUrl),
      this.zoomContainer.replaceChildren(this.currentZoomImage);
    const t = this.zoomContainer?.querySelector(".gallery-viewer__zoom-image");
    t && this.enableCustomZoom(t);
  }
  enableCustomZoom(e) {
    if (!e) return;
    this.removeZoomLens();
    const t = e.parentElement;
    if (!t) return;
    "static" === window.getComputedStyle(t).position &&
      (t.style.position = "relative");
    const i = e.style.transform || "",
      n = e.style.transformOrigin || "",
      s = e.style.transition || "",
      r = e.style.cursor || "";
    (e.style.transition = "transform 0.3s ease-out"),
      (e.style.cursor = "zoom-in");
    let o = !1;
    const a = (t) => {
        if (!o) return;
        const i = e.getBoundingClientRect(),
          n = t.clientX - i.left,
          s = t.clientY - i.top,
          r = (n / i.width) * 100,
          a = (s / i.height) * 100;
        e.style.transformOrigin = `${r}% ${a}%`;
      },
      l = (t) => {
        if (!o || 1 !== t.touches.length) return;
        const i = t.touches[0],
          n = e.getBoundingClientRect(),
          s = i.clientX - n.left,
          r = i.clientY - n.top,
          a = (s / n.width) * 100,
          l = (r / n.height) * 100;
        e.style.transformOrigin = `${a}% ${l}%`;
      },
      c = () => {
        (o = !0),
          (e.style.transform = "scale(2)"),
          (e.style.cursor = "zoom-out"),
          (t.style.overflow = "hidden");
      },
      d = () => {
        (o = !1),
          (e.style.transform = i),
          (e.style.transformOrigin = n),
          (e.style.cursor = "zoom-in"),
          (t.style.overflow = "");
      };
    e.addEventListener("mouseenter", c),
      e.addEventListener("mousemove", a),
      e.addEventListener("mouseleave", d),
      e.addEventListener("touchstart", (e) => {
        1 === e.touches.length && (c(), l(e));
      }),
      e.addEventListener("touchmove", l),
      e.addEventListener("touchend", d),
      e.addEventListener("touchcancel", d),
      (e._zoomHandlers = {
        mouseenter: c,
        mousemove: a,
        mouseleave: d,
        touchstart: c,
        touchmove: l,
        touchend: d,
        touchcancel: d,
        originalStyles: {
          transform: i,
          transformOrigin: n,
          transition: s,
          cursor: r,
        },
      });
  }
  getCursorPos(e, t) {
    const i = t.getBoundingClientRect();
    return { x: e.clientX - i.left, y: e.clientY - i.top };
  }
  removeZoomLens() {
    this.querySelectorAll("img").forEach((e) => {
      if (e._zoomHandlers) {
        e.removeEventListener("mouseenter", e._zoomHandlers.mouseenter),
          e.removeEventListener("mousemove", e._zoomHandlers.mousemove),
          e.removeEventListener("mouseleave", e._zoomHandlers.mouseleave),
          e.removeEventListener("touchstart", e._zoomHandlers.touchstart),
          e.removeEventListener("touchmove", e._zoomHandlers.touchmove),
          e.removeEventListener("touchend", e._zoomHandlers.touchend),
          e.removeEventListener("touchcancel", e._zoomHandlers.touchcancel);
        const t = e._zoomHandlers.originalStyles;
        (e.style.transform = t.transform),
          (e.style.transformOrigin = t.transformOrigin),
          (e.style.transition = t.transition),
          (e.style.cursor = t.cursor),
          e.parentElement && (e.parentElement.style.overflow = ""),
          delete e._zoomHandlers;
      }
    }),
      document
        .querySelectorAll(".zoomContainer, .zoomWindowContainer")
        .forEach((e) => e.remove());
  }
  selectPreviousThumb(e) {
    if ((e && e.preventDefault(), this.thumbContainer.childElementCount < 2))
      return;
    let t = this.thumbContainer.querySelector(
      ".gallery-viewer__thumb--active"
    ).previousElementSibling;
    for (; !t || !t.offsetParent; )
      t = t ? t.previousElementSibling : this.thumbContainer.lastElementChild;
    this.selectThumb(t);
  }
  selectNextThumb(e) {
    if ((e && e.preventDefault(), this.thumbContainer.childElementCount < 2))
      return;
    let t = this.thumbContainer.querySelector(
      ".gallery-viewer__thumb--active"
    ).nextElementSibling;
    for (; !t || !t.offsetParent; )
      t = t ? t.nextElementSibling : this.thumbContainer.firstElementChild;
    this.selectThumb(t);
  }
  stopTrackingTouch() {
    (this.pinchTracking.isTracking = !1), (this.touchTracking.isTracking = !1);
  }
  trackInputMovement(e) {
    if ((e.preventDefault(), "touchmove" === e.type && e.touches.length > 0)) {
      const t = e.touches[0];
      if (
        (this.touchTracking.isTracking
          ? (this.alterCurrentPanBy(
              (t.clientX - this.touchTracking.lastTouchX) *
                this.touchPanModifier,
              (t.clientY - this.touchTracking.lastTouchY) *
                this.touchPanModifier
            ),
            (this.touchTracking.lastTouchX = t.clientX),
            (this.touchTracking.lastTouchY = t.clientY))
          : ((this.touchTracking.isTracking = !0),
            (this.touchTracking.lastTouchX = t.clientX),
            (this.touchTracking.lastTouchY = t.clientY)),
        2 === e.touches.length)
      ) {
        const i = e.touches[1],
          n = Math.sqrt(
            (t.clientX - i.clientX) ** 2 + (t.clientY - i.clientY) ** 2
          );
        if (this.pinchTracking.isTracking) {
          const e = n - this.pinchTracking.lastPinchDistance;
          this.alterCurrentTransformZoomBy(e * this.pinchZoomMultiplier),
            (this.pinchTracking.lastPinchDistance = n);
        } else
          (this.pinchTracking.lastPinchDistance = n),
            (this.pinchTracking.isTracking = !0);
      } else this.pinchTracking.isTracking = !1;
    } else this.panZoomImageFromCoordinate(e.clientX, e.clientY);
  }
  trackWheel(e) {
    e.preventDefault(),
      0 !== e.deltaY &&
        this.alterCurrentTransformZoomBy(e.deltaY * this.wheelZoomMultiplier);
  }
  onThumbClick(e, t) {
    e.preventDefault(), this.selectThumb(t);
  }
  onZoomContainerClick(e) {
    e.preventDefault();
    const epsilon = 1e-4;
    if (this.currentTransform.zoom > 1 + epsilon) {
      this.currentTransform.zoom = 1;
      this.alterCurrentTransformZoomBy(0);
    } else {
      this.currentTransform.zoom = 1.5;
      this.alterCurrentTransformZoomBy(0);
      this.panZoomImageFromCoordinate(e.clientX, e.clientY);
    }
  }
  handleKeyup(e) {
    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault(), this.selectPreviousThumb();
        break;
      case "ArrowRight":
        e.preventDefault(), this.selectNextThumb();
    }
  }
};
window.customElements.define("gallery-viewer", GalleryViewer);
const LinkDropdown = class extends HTMLElement {
  constructor() {
    super(),
      (this.open = !1),
      (this.button = this.querySelector(".link-dropdown__button")),
      this.button.addEventListener("click", this.toggle.bind(this));
  }
  connectedCallback() {
    this.open && this.addDismissListener();
  }
  disconnectedCallback() {
    this.open && this.removeDismissListener();
  }
toggle(e, t) {
  if (!t) {
    e.preventDefault();
    e.stopPropagation();
  }

  const isClosed = this.button.getAttribute("aria-expanded") === "false";
  this.button.setAttribute("aria-expanded", isClosed);

  const dropdown = this.button.nextElementSibling;
  const linkDropdown = this.button.closest(".link-dropdown");
  const buttonText = this.button.querySelector(".link-dropdown__button-text");

  // READ phase (all measurements first)
  const buttonWidth = this.button.clientWidth;
  let newWidth = buttonWidth;

  if (!linkDropdown.classList.contains("link-dropdown--left-aligned")) {
    if (isClosed) {
      const dropdownWidth = dropdown.clientWidth;
      const computedStyle = getComputedStyle(dropdown);
      const linkPadding = parseInt(
        getComputedStyle(dropdown.querySelector(".link-dropdown__link"))
          .paddingInlineStart,
        10
      );
      const rtl = document.querySelector("html[dir=rtl]");
      newWidth = dropdownWidth +
                 (rtl ? parseInt(computedStyle.left, 10) : parseInt(computedStyle.right, 10)) -
                 linkPadding;
    } else {
      const buttonPadding = parseInt(getComputedStyle(this.button).paddingInlineEnd, 10);
      const textWidth = Math.ceil(buttonText.getBoundingClientRect().width);
      newWidth = buttonPadding + textWidth;
    }
  }

  // WRITE phase (apply all changes together in next frame)
  requestAnimationFrame(() => {
    this.button.style.width = `${newWidth}px`;

    if (isClosed) {
      this.open = true;
      this.addDismissListener();
    } else {
      this.open = false;
      this.removeDismissListener();
    }
  });
}

  addDismissListener() {
    (this.dismissCallback = this.toggle.bind(this, !0)),
      document.addEventListener("click", this.dismissCallback);
  }
  removeDismissListener() {
    document.removeEventListener("click", this.dismissCallback),
      (this.dismissCallback = null);
  }
};
window.customElements.define("link-dropdown", LinkDropdown);
const MainNavigation = class extends HTMLElement {
  constructor() {
    super(),
      (this.navHoverDelay = 250),
      (this.navLastOpenDropdown = null),
      (this.navOpenTimeoutId = -1),
      (this.navItemsWithChildren = this.querySelectorAll(
        ".navigation__tier-1 > .navigation__item--with-children"
      )),
      this.setupHoverEvents(),
      this.setupTouchEvents(),
      this.setupClickEvents(),
      this.setupKeyboardEvents(),
      this.addEventListener("mouseenter", this.handleNavHover.bind(this)),
      this.addEventListener("mouseleave", this.handleNavHover.bind(this));
  }
  setupHoverEvents() {
    this.navItemsWithChildren.forEach((e) => {
      e.addEventListener("mouseenter", this.onNavParentHoverIn.bind(this)),
        e.addEventListener("mouseleave", this.onNavParentHoverOut.bind(this));
    });
  }
  setupTouchEvents() {
    theme.addDelegateEventListener(
      this,
      "touchstart",
      ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
      (e, t) => this.handleTouch(e, t),
      { passive: !0 }
    ),
      theme.addDelegateEventListener(
        this,
        "touchend",
        ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
        (e, t) => this.handleTouch(e, t)
      );
  }
  setupClickEvents() {
    theme.addDelegateEventListener(
      this,
      "click",
      ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
      this.onNavParentHoverIn.bind(this)
    ),
      this.querySelectorAll(
        '.navigation__link[href="#"][aria-haspopup="true"]'
      ).forEach((e) => {
        e.addEventListener("click", (e) => {
          e.preventDefault(),
            e.currentTarget.nextElementSibling.dispatchEvent(
              new Event("click", { bubbles: !0 })
            );
        });
      });
  }
  setupKeyboardEvents() {
    theme.addDelegateEventListener(
      this,
      "keydown",
      ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
      this.onNavKeydown.bind(this)
    );
  }
 ensureDropdownsInPageBounds() {
  if (!this.smallMenuItems) {
    this.smallMenuItems = this.querySelectorAll(
      ".navigation__item--with-small-menu > .navigation__child-tier"
    );
  }
 
  const layoutData = [];
  this.smallMenuItems.forEach((el) => {
    const parentRect = el.parentElement.getBoundingClientRect();
    const rect = el.getBoundingClientRect();
    const offset = window.innerWidth - (parentRect.left + rect.width);
    layoutData.push({ el, offset });
  });
 
  requestAnimationFrame(() => {
    layoutData.forEach(({ el, offset }) => {
      if (offset < 25) {
        el.style.setProperty("--nav-side-offset", `${offset - 25}px`);
      } else {
        el.style.removeProperty("--nav-side-offset");
      }
    });
  });
}

  connectedCallback() {
    (this.debouncedEnsureDropdownsInPageBounds = debounce(
      this.ensureDropdownsInPageBounds.bind(this),
      200
    )),
      this.debouncedEnsureDropdownsInPageBounds(),
      this.setupResizeObserver(),
      this.setupProxyNavigation(),
      this.createMobileNavigation();
  }
  setupResizeObserver() {
    (this.resizeObserver = new ResizeObserver((e) => {
      for (let t = 0; t < e.length; t += 1) {
        const i = e[t];
        if (i.contentBoxSize || i.contentRect) {
          this.debouncedEnsureDropdownsInPageBounds();
          break;
        }
      }
    })),
      this.resizeObserver.observe(this);
  }
  setupProxyNavigation() {
    (this.proxyTier1Nav = document.getElementById(this.dataset.proxyNav)),
      this.proxyTier1Nav &&
        ((this.proxyTier1NavBoundEvents = []),
        this.setupProxySmallMenu(),
        this.setupProxyLargeMenu(),
        this.setupProxyTransparentHeader());
  }
  setupProxySmallMenu() {
    const e = this.onProxyNavEnterSmallMenu.bind(this);
    this.proxyTier1Nav
      .querySelectorAll(".navigation__item--with-small-menu")
      .forEach((t) => {
        t.addEventListener("mouseenter", e),
          this.proxyTier1NavBoundEvents.push({
            element: t,
            name: "mouseenter",
            fn: e,
          });
      }),
      this.proxyTier1NavBoundEvents.push({
        element: this.proxyTier1Nav,
        name: "touchstart",
        fn: theme.addDelegateEventListener(
          this.proxyTier1Nav,
          "touchstart",
          ".navigation__item--with-small-menu",
          this.onProxyNavEnterSmallMenu.bind(this),
          { passive: !0 }
        ),
      });
  }
  setupProxyLargeMenu() {
    const e = (e) => {
      const t = [...e.currentTarget.parentNode.children].indexOf(
        e.currentTarget
      );
      this.querySelectorAll(".navigation__tier-1 > .navigation__item")[
        t
      ].dispatchEvent(new Event(e.type));
    };
    this.proxyTier1Nav
      .querySelectorAll(
        ".navigation__tier-1 > .navigation__item--with-children"
      )
      .forEach((t) => {
        t.addEventListener("mouseenter", e),
          this.proxyTier1NavBoundEvents.push({
            element: t,
            name: "mouseenter",
            fn: e,
          }),
          t.addEventListener("mouseleave", e),
          this.proxyTier1NavBoundEvents.push({
            element: t,
            name: "mouseleave",
            fn: e,
          });
      });
    const t = ["touchstart", "touchend", "click"];
    for (let e = 0; e < t.length; e += 1) {
      const i = t[e];
      this.proxyTier1NavBoundEvents.push({
        element: this.proxyTier1Nav,
        name: i,
        fn: theme.addDelegateEventListener(
          this.proxyTier1Nav,
          i,
          ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
          (e, t) => {
            const i = [...t.parentNode.parentNode.children].indexOf(
                t.parentNode
              ),
              n = this.querySelectorAll(
                ".navigation__tier-1 > .navigation__item"
              )[i].firstElementChild;
            this.handleTouch(e, n);
          },
          { passive: "touchstart" === i }
        ),
      });
    }
    this.proxyTier1NavBoundEvents.push({
      element: this.proxyTier1Nav,
      name: "keydown",
      fn: theme.addDelegateEventListener(
        this.proxyTier1Nav,
        "keydown",
        ".navigation__tier-1 > .navigation__item--with-children > .navigation__link",
        (e, t) => {
          if ("Enter" === e.key) {
            const i = [...t.parentNode.parentNode.children].indexOf(
                t.parentNode
              ),
              n = this.querySelectorAll(
                ".navigation__tier-1 > .navigation__item"
              )[i].firstElementChild;
            t.setAttribute(
              "aria-expanded",
              !n.parentElement.classList.contains(
                "navigation__item--show-children"
              )
            ),
              this.onNavKeydown(e, n);
          }
        }
      ),
    });
  }
  setupProxyTransparentHeader() {
    const e = this.handleNavHover.bind(this);
    this.proxyTier1Nav.addEventListener("mouseenter", e),
      this.proxyTier1Nav.addEventListener("mouseleave", e),
      this.proxyTier1NavBoundEvents.push({
        element: this.proxyTier1Nav,
        name: "mouseenter",
        fn: e,
      }),
      this.proxyTier1NavBoundEvents.push({
        element: this.proxyTier1Nav,
        name: "mouseleave",
        fn: e,
      });
  }
  createMobileNavigation() {
    const e = document.createElement("div");
    (e.innerHTML = this.querySelector(
      ".mobile-navigation-drawer-template"
    ).innerHTML),
      (this.mobileDrawer = e.firstElementChild),
      this.addAnnouncementBarItems(),
      theme.suffixIds(this.mobileDrawer, "MobileNav"),
      document
        .querySelector(".section-header")
        .insertAdjacentElement("afterend", this.mobileDrawer),
      this.setupMobileNavigationEvents();
  }
  addAnnouncementBarItems() {
    const e = this.mobileDrawer.querySelector(
        ".mobile-navigation-drawer__footer"
      ),
      t = document.querySelector(".announcement-bar .inline-menu"),
      i = document.querySelector(".announcement-bar .header-localization"),
      n = document.querySelector(".announcement-bar .social");
    if (t) {
      const i = t.cloneNode(!0);
      i.classList.remove("desktop-only"), e.appendChild(i);
    }
    if (i) {
      const t = i.cloneNode(!0);
      t.classList.remove("desktop-only"), e.appendChild(t);
      const n = t.querySelector("form");
      n &&
        n.addEventListener("change", (e) => {
          const t = e.target.previousElementSibling;
          t &&
            "INPUT" === t.tagName &&
            ((t.value = e.detail.selectedValue), e.currentTarget.submit());
        });
    }
    if (n) {
      const t = n.cloneNode(!0);
      t.classList.remove("desktop-only"), e.appendChild(t);
    }
  }
  setupMobileNavigationEvents() {
    (this.mobileNavHeader = this.mobileDrawer.querySelector(
      ".navigation__mobile-header"
    )),
      (this.mobileNavTitle =
        this.mobileDrawer.querySelector(".mobile-nav-title")),
      theme.addDelegateEventListener(
        this.mobileDrawer,
        "click",
        ".navigation__tier-1 > .navigation__item > .navigation__children-toggle",
        (e, t) => this.openSecondTier(e, t)
      ),
      "true" === this.mobileDrawer.dataset.mobileExpandWithEntireLink
        ? theme.addDelegateEventListener(
            this.mobileDrawer,
            "click",
            ".navigation__item--with-children > .navigation__link",
            (e, t) => {
              e.preventDefault(),
                t.nextElementSibling.dispatchEvent(
                  new Event("click", { bubbles: !0, cancelable: !0 })
                );
            }
          )
        : theme.addDelegateEventListener(
            this.mobileDrawer,
            "click",
            '.navigation__item--with-children > .navigation__link[href="#"]',
            (e, t) => {
              e.preventDefault(),
                t.nextElementSibling.dispatchEvent(
                  new Event("click", { bubbles: !0, cancelable: !0 })
                );
            }
          ),
      theme.addDelegateEventListener(
        this.mobileDrawer,
        "click",
        ".mobile-nav-back",
        (e) => this.closeSecondTier(e)
      ),
      theme.addDelegateEventListener(
        this.mobileDrawer,
        "click",
        ".mobile-nav-back-sub",
        (e) => this.closeThirdTier(e)
      ),
      theme.addDelegateEventListener(
        this.mobileDrawer,
        "click",
        ".navigation__tier-2 > .navigation__item > .navigation__children-toggle",
        (e, t) => this.toggleThirdTier(e, t)
      );
  }
openSecondTier(e, t) {
  e.preventDefault();

  const navItem = t.parentElement;
  const drawer = this.mobileDrawer;
  const drawerContainer = drawer.closest(".mobile-navigation-drawer");
  const titleEl = this.mobileNavTitle;
  const headerEl = this.mobileNavHeader;
  const nextTier = t.nextElementSibling;
  const backTitle = t.previousElementSibling?.getAttribute("data-back-title") || "Menu";
 
  navItem.classList.add("navigation__item--open");
  drawer.classList.add("mobile-navigation-drawer--child-open");
  titleEl.innerText = backTitle;
 
  const headerHeight = headerEl?.clientHeight || 0;
 
  requestAnimationFrame(() => {
    if (nextTier) nextTier.style.top = `${Math.ceil(headerHeight + 1)}px`;
  });
 
  drawerContainer?.scrollTo({ top: 0, left: 0, behavior: "instant" });
}


  closeSecondTier(e) {
    e.preventDefault(),
      this.mobileDrawer.classList.remove(
        "mobile-navigation-drawer--child-open"
      ),
      this.mobileDrawer
        .querySelectorAll(".navigation__tier-2 > .navigation__item")
        .forEach((e) => {
          e.classList.remove("navigation__item--open");
          const t = e.querySelector(".navigation__tier-3-container");
          t && (t.style.height = "");
        }),
      this.mobileDrawer
        .querySelectorAll(".navigation__tier-1 > .navigation__item")
        .forEach((e) => {
          e.classList.remove("navigation__item--open");
        }),
      (this.mobileNavTitle.innerText = "Menu");
  }
  closeThirdTier(e) {
    e.preventDefault(),
      this.mobileDrawer
        .querySelectorAll(".navigation__tier-2 > .navigation__item--open")
        .forEach((e) => {
          e.classList.remove("navigation__item--open");
          const t = e.querySelector(".navigation__tier-3-container");
          t && (t.style.height = "");
        }),
      (this.mobileNavTitle.innerText = "Back to menu");
  }
 toggleThirdTier(e, t) {
  e.preventDefault();

  const drawer = this.mobileDrawer;
  const tier2Items = drawer.querySelectorAll(".navigation__tier-2 > .navigation__item");
  const titleEl = this.mobileNavTitle;
  const nextTier = t.nextElementSibling;
  const parentItem = t.parentElement;

  // Update mobile nav title
  titleEl.innerText =
    window.innerWidth > 767 && window.innerWidth < 1025
      ? "Back to menu"
      : t.previousElementSibling?.dataset.backTitle || "Back";

  // Close all tier-2 items and reset tier-3 heights (batch writes)
  tier2Items.forEach((item) => {
    item.classList.remove("navigation__item--open");
    const tier3 = item.querySelector(".navigation__tier-3-container");
    if (tier3) tier3.style.height = "";
  });

  const shouldOpen = !parentItem.classList.contains("navigation__item--open");

  if (nextTier) {
    // Read layout first
    const childHeight = shouldOpen
      ? nextTier.firstElementChild?.clientHeight || 0
      : 0;

    // Write styles in next frame to avoid reflow
    requestAnimationFrame(() => {
      if (shouldOpen) {
        parentItem.classList.add("navigation__item--open");
        nextTier.style.height = `${childHeight}px`;
      } else {
        parentItem.classList.remove("navigation__item--open");
        nextTier.style.height = "";
      }
    });
  }
}

  handleNavHover(e) {
    this.closest(".section-header").classList.toggle(
      "section-header--nav-hover",
      "mouseenter" === e.type
    );
  }
  onNavParentHoverIn(e) {
    const t = e.currentTarget;
    clearTimeout(this.navOpenTimeoutId),
      clearTimeout(t.dataset.navCloseTimeoutId);
    const i = [...t.parentNode.children].filter(
      (e) => e !== t && e.classList.contains("navigation__item--show-children")
    );
    i
      .filter((e) => e !== this.navLastOpenDropdown)
      .forEach((e) => e.classList.remove("navigation__item--show-children")),
      (this.navLastOpenDropdown = t);
    const n = 0 === i.length ? 0 : this.navHoverDelay,
      s = setTimeout(() => {
        [...t.parentNode.children].forEach((e) => {
          e === t
            ? e.classList.add("navigation__item--show-children")
            : e.classList.remove("navigation__item--show-children");
        }),
          t
            .closest(".section-header")
            .classList.add("section-header--nav-open");
      }, n);
    (this.navOpenTimeoutId = s),
      (t.dataset.navOpenTimeoutId = s),
      t.firstElementChild.setAttribute("aria-expanded", !0);
  }
  onNavParentHoverOut(e) {
    const t = e.currentTarget;
    clearTimeout(t.dataset.navOpenTimeoutId),
      (t.dataset.navCloseTimeoutId = setTimeout(() => {
        t.classList.remove("navigation__item--show-children"),
          t
            .closest(".section-header")
            .classList.remove("section-header--nav-open");
      }, this.navHoverDelay)),
      t.firstElementChild.setAttribute("aria-expanded", !1);
  }
  handleTouch(e, t) {
    window.innerWidth > 767 &&
      ("touchstart" === e.type
        ? (t.dataset.touchstartedAt = e.timeStamp.toString())
        : "touchend" === e.type
        ? e.timeStamp - parseInt(t.dataset.touchstartedAt, 10) < 1e3 &&
          ((t.dataset.touchOpenTriggeredAt = e.timeStamp.toString()),
          t.parentElement.classList.contains("navigation__item--show-children")
            ? t.parentElement.dispatchEvent(new Event("mouseleave"))
            : (this.querySelectorAll(
                ".navigation__item--show-children"
              ).forEach((e) => e.dispatchEvent(new Event("mouseleave"))),
              t.parentElement.dispatchEvent(new Event("mouseenter"))),
          e.preventDefault(),
          e.stopPropagation())
        : "click" === e.type &&
          t.dataset.touchOpenTriggeredAt &&
          e.timeStamp - parseInt(t.dataset.touchOpenTriggeredAt, 10) < 1e3 &&
          (e.preventDefault(), e.stopPropagation()));
  }
  onNavKeydown(e, t) {
    "Enter" === e.key &&
      (t.parentElement.classList.contains("navigation__item--show-children")
        ? t.parentElement.dispatchEvent(new Event("mouseleave"))
        : t.parentElement.dispatchEvent(new Event("mouseenter")),
      e.preventDefault());
  }
  onProxyNavEnterSmallMenu(e, t) {
  const target = t || e.currentTarget;
  const isRTL = document.documentElement.dir === "rtl";

  // Batch layout reads
  const siblings = Array.from(target.parentNode.children);
  const index = siblings.indexOf(target);
  const navItems = this.querySelectorAll(".navigation__tier-1 > .navigation__item");
  const container = navItems[index]?.querySelector(".navigation__tier-2-container");
  if (!container) return;

  // Collect layout info first
  const offsetParent = container.offsetParent;
  const offsetParentWidth = offsetParent?.clientWidth || 0;
  const offsetLeft = theme.getOffsetLeftFromDoc(target);
  const targetWidth = target.clientWidth;

  // Batch layout writes asynchronously to avoid layout thrash
  requestAnimationFrame(() => {
    if (isRTL) {
      const newRight = offsetParentWidth - (offsetLeft + targetWidth);
      container.style.right = `${newRight}px`;
      container.style.removeProperty("left");
    } else {
      container.style.left = `${offsetLeft}px`;
      container.style.removeProperty("right");
    }
  });
}

  disconnectedCallback() {
    if (
      (this.mobileDrawer && this.mobileDrawer.remove(),
      this.resizeObserver && this.resizeObserver.disconnect(),
      this.proxyTier1NavBoundEvents)
    )
      for (let e = 0; e < this.proxyTier1NavBoundEvents.length; e += 1)
        this.proxyTier1NavBoundEvents[e].element.removeEventListener(
          this.proxyTier1NavBoundEvents[e].name,
          this.proxyTier1NavBoundEvents[e].fn
        );
  }
};
window.customElements.define("main-navigation", MainNavigation);
const ProductBlock = class extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.init.bind(this));
  }
  init() {
    (this.images = Array.from(this.querySelectorAll(".product-block__image"))),
      this.images.length > 1 &&
        (this.initImagePagination(),
        this.monitorSwatchSelection(),
        this.matches(":hover")
          ? this.lazyLoadAll()
          : this.initCustomLazyLoading());
  }
  initCustomLazyLoading() {
    setTimeout(() => {
      this.querySelector(
        ".product-block__image--show-on-hover"
      ).classList.remove("product-block__image--inactivated");
    }, 1e3),
      (this.boundLazyLoadAll = this.lazyLoadAll.bind(this)),
      this.addEventListener("mouseenter", this.boundLazyLoadAll),
      this.addEventListener("touchstart", this.boundLazyLoadAll, {
        passive: !0,
      });
  }
  lazyLoadAll() {
    this.querySelectorAll(".product-block__image--inactivated").forEach((e) =>
      e.classList.remove("product-block__image--inactivated")
    ),
      this.removeEventListener("mouseenter", this.boundLazyLoadAll),
      this.removeEventListener("touchstart", this.boundLazyLoadAll);
  }
  getImageAt(e) {
    return this.images[
      ((e % this.images.length) + this.images.length) % this.images.length
    ];
  }
  incrementActiveImage(e) {
    let t = 0;
    for (let e = 0; e < this.images.length; e += 1)
      if (this.images[e].classList.contains("product-block__image--active")) {
        t = e;
        break;
      }
    this.setActiveImage(t + e);
  }
  setActiveImage(e) {
    const t = this.getImageAt(e),
      i = this.getImageAt(e + 1);
    [...t.parentElement.children].forEach((e) => {
      e.classList.toggle("product-block__image--active", e === t),
        e.classList.toggle("product-block__image--show-on-hover", e === i);
    }),
      this.querySelectorAll(".product-block__image-dot").forEach((t, i) => {
        t.classList.toggle("product-block__image-dot--active", i === e);
      });
  }
  initImagePagination() {
    if (
      (this.querySelector(".image-page-button--next").addEventListener(
        "click",
        (e) => {
          e.preventDefault(), this.incrementActiveImage(1);
        }
      ),
      this.querySelector(".image-page-button--previous").addEventListener(
        "click",
        (e) => {
          e.preventDefault(), this.incrementActiveImage(-1);
        }
      ),
      !this.closest(".carousel, .product-grid--scrollarea"))
    ) {
      const e = this.querySelector(".image-cont--with-secondary-image");
      e.addEventListener(
        "touchstart",
        (e) => {
          (theme.productBlockTouchTracking = !0),
            (theme.productBlockTouchStartX = e.touches[0].clientX),
            (theme.productBlockTouchStartY = e.touches[0].clientY);
        },
        { passive: !0 }
      ),
        e.addEventListener(
          "touchmove",
          (e) => {
            if (
              theme.productBlockTouchTracking &&
              Math.abs(e.touches[0].clientY - theme.productBlockTouchStartY) <
                30
            ) {
              const t = e.touches[0].clientX - theme.productBlockTouchStartX;
              t > 25
                ? (this.incrementActiveImage(-1),
                  (theme.productBlockTouchTracking = !1))
                : t < -25 &&
                  (this.incrementActiveImage(1),
                  (theme.productBlockTouchTracking = !1));
            }
          },
          { passive: !0 }
        ),
        e.addEventListener("touchend", () => {
          theme.productBlockTouchTracking = !1;
        });
    }
  }
  onSelectSwatch(e) {
    e.preventDefault();
    let t = -1;
    for (let i = 0; i < this.images.length; i += 1)
      if (this.images[i].dataset.mediaId === e.currentTarget.dataset.media) {
        t = i;
        break;
      }
    if (t < 0) return;
    this.setActiveImage(t);
    const { optionName: i } = e.currentTarget.closest(
        ".product-block-options"
      ).dataset,
      n = e.currentTarget.dataset.optionItem;
    this.querySelectorAll(".product-link, .quickbuy-toggle").forEach((e) => {
      const t = new URL(e.href),
        s = new URLSearchParams(t.search);
      s.set(i, n), (e.href = `${t.pathname}?${s}`), (e.rel = "nofollow");
    });
  }
  monitorSwatchSelection() {
    this.querySelectorAll("[data-media].product-block-options__item").forEach(
      (e) => {
        e.addEventListener("mouseenter", this.onSelectSwatch.bind(this)),
          e.addEventListener("click", this.onSelectSwatch.bind(this));
      }
    );
  }
};
window.customElements.define("product-block", ProductBlock);
const MediaGallery = class extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.section = this.closest(".js-product")),
      (this.mainImageContainer = this.querySelector(".main-image")),
      (this.slideshow = this.mainImageContainer?.querySelector(
        ".main-image carousel-slider"
      )),
      (this.collage = this.querySelector(".product-media-collage")),
      (this.xrButton = this.querySelector("[data-shopify-xr]")),
      (this.variantPicker = this.section?.querySelector("variant-picker")),
      (this.mediaGroupingEnabled =
        this.variantPicker &&
        this.hasAttribute("data-media-grouping-enabled") &&
        this.getMediaGroupData()),
      (this.mediaLists = [
        this.querySelectorAll(".main-image .slider__item"),
        this.querySelectorAll(".product-media-collage__item"),
        this.querySelectorAll(".thumbnails .slider__item"),
      ]),
      this.variantPicker)
    ) {
      const e = [this.variantPicker];
      this.slideshow?.offsetParent && e.push(this.slideshow);
      const t = this.querySelector("carousel-slider.thumbnails");
      t?.offsetParent && e.push(t),
        theme.whenComponentLoaded(e, this.setFromVariantPicker.bind(this));
    }
    if (this.hasAttribute("data-zoom-enabled")) {
      (this.galleryModal = this.querySelector(
        ".js-media-zoom-template"
      )?.content.firstElementChild.cloneNode(!0)),
        this.galleryModal &&
          this.mediaLists.push(
            this.galleryModal.querySelectorAll(".gallery-viewer__thumb")
          );
      const e = this.mainImageContainer?.querySelector(
        ".gallery-viewer__zoom-image"
      );
      e && this.enableCustomZoom(e),
        this.section?.addEventListener("on:media-gallery:change", () => {
          const e = this.mainImageContainer?.querySelector(
            ".gallery-viewer__zoom-image"
          );
          e && this.enableCustomZoom(e);
        });
    }
    this.setupEventListeners(),
      this.hasAttribute("data-preload") &&
        setTimeout(() => {
          this.slideshow?.offsetParent &&
            this.slideshow.querySelectorAll(".theme-img").forEach((e) => {
              e.loading = "lazy";
            });
        }, 3e3);
  }
  setupEventListeners() {
    theme.addDelegateEventListener(
      this,
      "click",
      ".show-gallery",
      this.openGalleryViewer.bind(this)
    ),
      this.section?.addEventListener(
        "on:carousel-slider:select",
        this.selectMainMedia.bind(this)
      ),
      theme.addDelegateEventListener(
        this,
        "click",
        ".thumbnail",
        this.selectThumbnail.bind(this)
      ),
      this.section?.addEventListener(
        "on:variant:change",
        this.onVariantChange.bind(this)
      );
  }
enableCustomZoom(e) {
  if (!e) return;
  this.removeZoomLens();

  const container = e.parentElement;
  if (!container) return;

  // Ensure container positioning
  const containerStyle = window.getComputedStyle(container);
  if (containerStyle.position === "static") container.style.position = "relative";

  // Store original styles
  const original = {
    transform: e.style.transform || "",
    transformOrigin: e.style.transformOrigin || "",
    transition: e.style.transition || "",
    cursor: e.style.cursor || "",
  };

  e.style.transition = "transform 0.3s ease-out";
  e.style.cursor = "zoom-in";

  let zoomed = false;

  // Throttle mousemove with requestAnimationFrame
  let frameId = null;
  const onMouseMove = (evt) => {
    if (!zoomed) return;
    if (frameId) cancelAnimationFrame(frameId);

    frameId = requestAnimationFrame(() => {
      const rect = e.getBoundingClientRect();
      const x = ((evt.clientX - rect.left) / rect.width) * 100;
      const y = ((evt.clientY - rect.top) / rect.height) * 100;
      e.style.transformOrigin = `${x}% ${y}%`;
    });
  };

  const onMouseEnter = () => {
    zoomed = true;
    e.style.transform = "scale(2)";
    e.style.cursor = "zoom-out";
    container.style.overflow = "hidden";
  };

  const onMouseLeave = () => {
    zoomed = false;
    e.style.transform = original.transform;
    e.style.transformOrigin = original.transformOrigin;
    e.style.cursor = "zoom-in";
    container.style.overflow = "";
  };

  e.addEventListener("mouseenter", onMouseEnter);
  e.addEventListener("mousemove", onMouseMove);
  e.addEventListener("mouseleave", onMouseLeave);

  e._zoomHandlers = {
    mouseenter: onMouseEnter,
    mousemove: onMouseMove,
    mouseleave: onMouseLeave,
    originalStyles: original,
  };
}

  getCursorPos(event, element) {
  if (!element) return { x: 0, y: 0 };

  const rect = element.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;

  return { x, y };
}

 removeZoomLens() {
  // Reset all zoomed images
  this.querySelectorAll("img").forEach((img) => {
    if (!img._zoomHandlers) return;

    const { mouseenter, mousemove, mouseleave, originalStyles } = img._zoomHandlers;

    // Remove event listeners
    img.removeEventListener("mouseenter", mouseenter);
    img.removeEventListener("mousemove", mousemove);
    img.removeEventListener("mouseleave", mouseleave);

    // Restore original styles in a single frame to avoid layout thrashing
    requestAnimationFrame(() => {
      img.style.transform = originalStyles.transform;
      img.style.transformOrigin = originalStyles.transformOrigin;
      img.style.transition = originalStyles.transition;
      img.style.cursor = originalStyles.cursor;

      if (img.parentElement) {
        img.parentElement.style.overflow = "";
      }

      delete img._zoomHandlers;
    });
  });

  // Remove zoom containers
  document.querySelectorAll(".zoomContainer, .zoomWindowContainer").forEach((el) => el.remove());
}

  setFromVariantPicker() {
    if (this.mediaGroupingEnabled) this.setMediaGroupOnFirstLoad();
    else {
      const e = this.variantPicker.getSelectedVariant();
      e && e.featured_media && this.setActiveMedia(e.featured_media.id, !0, !0);
    }
  }
  setMediaGroupOnFirstLoad() {
    this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors());
    const e = this.variantPicker.getSelectedVariant();
    if (e && e.featured_media)
      return void this.setActiveMedia(e.featured_media.id, !0, !0);
    const t = this.querySelector(".thumbnails .slider__item:not([hidden])");
    t && this.setActiveMedia(t.dataset.mediaId, !1, !0);
  }
  static hoverMainImage(e) {
    MediaGallery.loadImage(
      e.currentTarget.querySelector(".slider__item.is-active a.show-gallery")
    );
  }
  openGalleryViewer(e, t) {
    e.preventDefault();
    const i = e.target;
    if (i.matches(".zoom_icon_media_mobile") || i.matches(".zoom_icon_media")) {
      if (!this.galleryModal) return;
      this.galleryModal.parentElement ||
        document.body.appendChild(this.galleryModal),
        this.galleryModal.open(t);
      const e = this.galleryModal.querySelector("gallery-viewer");
      e && (e.init(t.getAttribute("href")), e.focus()),
        this.hasAttribute("data-preload") &&
          this.mediaLists[0].forEach((e) => {
            const t = e.querySelector("a.show-gallery");
            t && MediaGallery.loadImage(t);
          });
      const i = e?.querySelector(".gallery-viewer__zoom-image");
      i && this.enableCustomZoom(i);
    }
  }
  static loadImage(e) {
    if (!e || e.hasAttribute("data-loading") || e.hasAttribute("data-loaded"))
      return;
    e.setAttribute("data-loading", "");
    const t = new Image();
    t.addEventListener(
      "load",
      () => {
        e.removeAttribute("data-loading"), e.setAttribute("data-loaded", "");
      },
      { once: !0 }
    ),
      (t.src = e.href);
  }
  onVariantChange(e) {
    if (
      (this.mediaGroupingEnabled &&
        this.setActiveMediaGroup(this.getMediaGroupFromOptionSelectors(e)),
      e.detail.variant && e.detail.variant.featured_media)
    )
      this.setActiveMedia(e.detail.variant.featured_media.id, !0);
    else if (this.mediaGroupChanged) {
      const e = this.querySelector(".thumbnails .slider__item:not([hidden])");
      e && this.setActiveMedia(e.dataset.mediaId, !0);
    }
  }
  getMediaGroupFromOptionSelectors(e) {
    return e
      ? e.detail.selectedOptions[this.getMediaGroupData().groupOptionIndex]
      : this.variantPicker.getSelectedOptions()[
          this.getMediaGroupData().groupOptionIndex
        ];
  }
  getMediaGroupData() {
    if (void 0 === this.variantMediaData) {
      const e = this.querySelector(".js-data-variant-media");
      if (e)
        try {
          this.variantMediaData = JSON.parse(e.textContent);
        } catch (e) {
          this.variantMediaData = !1;
        }
      else this.variantMediaData = !1;
    }
    return this.variantMediaData;
  }
  setActiveMediaGroup(e) {
    if (
      ((this.mediaGroupChanged = this.currentMediaGroup !== e),
      (this.currentMediaGroup = e),
      !this.mediaGroupChanged)
    )
      return;
    if (!e)
      return void this.mediaLists.forEach((e) => {
        e.forEach((e) => {
          e.hidden = !1;
        });
      });
    const t = this.getMediaGroupData();
    t &&
      this.mediaLists.forEach((i) => {
        if (
          (i.forEach((i) => {
            const n = t.media[i.dataset.mediaId];
            if (n) {
              const t = n.group,
                s = t === e || !0 === t;
              (i.hidden = !s), i.classList.toggle("is-showing", s);
            }
          }),
          [...i].forEach((e) => {
            const i = t.media[e.dataset.mediaId];
            i &&
              !0 === i.group &&
              ("start" === i.position
                ? e.parentElement.prepend(e)
                : e.parentElement.append(e));
          }),
          [...i]
            .filter((e) => e.hidden)
            .forEach((e) => e.parentElement.append(e)),
          i.length > 0)
        ) {
          const e = i[0].closest("carousel-slider");
          e && e.offsetParent && e.refresh && e.refresh();
        }
      });
  }
  setActiveMedia(e, t = !0, i = !1) {
    const n = e.toString(),
      s = this.mainImageContainer?.querySelector(`[data-media-id="${n}"]`);
    if (
      t &&
      (this.slideshow &&
        this.slideshow.hasAttribute("loaded") &&
        this.slideshow.offsetParent,
      this.collage && this.collage.offsetParent && !i)
    ) {
      this.collage.querySelector(`[data-media-id="${n}"]`) &&
        (clearTimeout(this.collage.dataset.highlightTimeoutId),
        this.mediaGroupChanged ||
          (this.collage
            .querySelectorAll(".product-media-collage__item")
            .forEach((e) => {}),
          (this.collage.dataset.highlightTimeoutId = setTimeout(() => {},
          1200))));
    }
    if (
      (this.mediaLists.forEach((e) => {
        e.forEach((e) => {
          if (e.dataset.mediaId === n) {
            e.classList.add("is-active");
            const t = e.closest("carousel-slider");
            t && t.offsetParent;
          } else e.classList.remove("is-active");
        });
      }),
      window.pauseAllMedia && window.pauseAllMedia(),
      s)
    ) {
      const e = s.querySelector("deferred-media, product-model");
      e && e.loadContent && e.loadContent(!0);
      const t = s.querySelector("video");
      t && t.play().catch(() => {});
    }
    this.xrButton &&
      this.mediaIsModel(e) &&
      (this.xrButton.dataset.shopifyModel3dId = e),
      document.dispatchEvent(
        new CustomEvent("on:media-gallery:change", {
          bubbles: !0,
          cancelable: !1,
        })
      );
  }
  mediaIsModel(e) {
    return !!this.querySelector(`.product-media--model[data-model-id="${e}"]`);
  }
  selectThumbnail(e, t) {
    e.preventDefault(), this.setActiveMedia(t.parentNode.dataset.mediaId, !0);
  }
  selectMainMedia(e) {
    e.detail &&
      e.detail.slide &&
      e.detail.slide.dataset.mediaId &&
      this.setActiveMedia(e.detail.slide.dataset.mediaId, !1);
  }
};
window.customElements.define("media-gallery", MediaGallery);
const ProductForm = class extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.form = this.querySelector(".js-product-form")),
      (this.hasSize = this.querySelector("[is-size-option]")),
      this.form)
    ) {
      (this.form.querySelector('[name="id"]').required = !0),
        "no-js" !== theme.settings.afterAddToCart &&
          ((this.submitBtn = this.querySelector('[name="add"]')),
          (this.wishlistBtn = this.querySelector(".atw-button-custom")),
          (this.disabledSubmitBtn = this.querySelector(
            ".disabled-add-to-cart"
          )),
          this.wishlistBtn?.addEventListener("click", this.validate.bind(this)),
          this.form.addEventListener("submit", this.handleSubmit.bind(this)),
          this.disabledSubmitBtn?.addEventListener(
            "click",
            this.disableTheSubmitButton.bind(this)
          ));
    }
  }
  disableTheSubmitButton(e) {
    if (
      (e.preventDefault(),
      this.hasSize && !this.querySelector("[is-size-option]:checked"))
    ) {
      this.validate();
    }
    this.disabledSubmitBtn?.setAttribute("disabled", "true"),
      (this.disabledSubmitBtn.textContent = theme.strings.noStock);
  }
  async handleSubmit(e) {
    if (
      (e.preventDefault(),
      this.hasSize && this.querySelector("[is-size-option]:checked"),
      "true" === this.submitBtn.getAttribute("aria-disabled"))
    )
      return;
    this.setErrorMsgState();
    if (!this.validate()) return;
    if (
      (this.submitBtn.setAttribute("aria-disabled", "true"),
      this.submitBtn.classList.add("is-loading"),
      this.submitBtn.classList.contains("disabled"))
    )
      return (
        this.submitBtn.setAttribute("disabled", "true"),
        void (this.submitBtn.textContent = theme.strings.noStock)
      );
    const t = new FormData(this.form),
      i = ["page-header", "cart-drawer"]
        .map((e) => document.querySelector(e))
        .filter((e) => e),
      n = i.map((e) => e.dataset.sectionId);
    t.append("sections_url", window.location.pathname),
      t.append("sections", n.join(","));
    const s = {
      method: "POST",
      headers: {
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: t,
    };
    try {
      const e = await fetch(theme.routes.cartAdd, s),
        t = await e.json();
      let n = "string" == typeof t.description ? t.description : t.message;
      if (
        (t.errors &&
          "object" == typeof t.errors &&
          (n = Object.entries(t.errors).map((e) => e[1].join(", "))),
        t.status && this.setErrorMsgState(n),
        !e.ok)
      )
        throw new Error(e.status);
      if (document.querySelector(".template-cart")) {
        const e = document.querySelector("cart-form");
        e && e.enableAjaxUpdate && e.refresh();
      } else if ("page" === theme.settings.afterAddToCart)
        setTimeout(() => {
          window.location.href = theme.routes.cart;
        }, 300);
      else if (
        (t.sections && i.length === Object.keys(t.sections).length
          ? i.forEach((e) => {
              e.updateFromCartChange(t.sections[e.dataset.sectionId]);
            })
          : this.dispatchEvent(
              new CustomEvent("on:cart:change", { bubbles: !0 })
            ),
        "notification" === theme.settings.afterAddToCart)
      ) {
        const e = t.options_with_values || [],
          i = e.find((e) => e.name.toLowerCase().includes("size")),
          n = e.find((e) => e.name.toLowerCase().includes("color")),
          s = i ? `Size ${i.value}` : "",
          r = n
            ? ` in ${n.value}`
            : window.productColor
            ? ` in ${window.productColor}`
            : "",
          o = `${s} ${t.product_title}${r} was successfully added to cart.`;
        window.addToCartNotification(o);
      } else
        "drawer" === theme.settings.afterAddToCart &&
          document.querySelector(".js-cart-drawer").open(this.submitBtn);
          const de = t.options_with_values || [],
          di = de.find((de) => de.name.toLowerCase().includes("size")),
          dn = de.find((de) => de.name.toLowerCase().includes("color")),
          ds = di ? `Size ${di.value}` : "",
          dr = dn
            ? ` in ${dn.value}`
            : window.productColor
            ? ` in ${window.productColor}`
            : "",
          dO = `${ds} ${t.product_title}${dr} was successfully added to cart.`;
        // window.addToCartNotification(dO);
      this.dispatchEvent(
        new CustomEvent("on:cart:add", {
          bubbles: !0,
          detail: { variantId: t.variant_id },
        })
      ),
        this.submitBtn.classList.add("is-success"),
        this.submitBtn.removeAttribute("aria-disabled"),
        setTimeout(() => {
          this.submitBtn.classList.remove("is-loading"),
            this.submitBtn.classList.remove("is-success");
        }, 2e3);
    } catch (e) {
      console.log(e),
        this.dispatchEvent(
          new CustomEvent("on:cart:error", {
            bubbles: !0,
            detail: { error: this.errorMsg.textContent },
          })
        ),
        this.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: !0 })),
        this.submitBtn.classList.remove("is-loading"),
        this.submitBtn.classList.remove("is-success"),
        this.submitBtn.removeAttribute("aria-disabled");
    }
  }
  setErrorMsgState(e = !1) {
    const t = this.querySelector(".product-form-error-wrapper");
    if (
      t &&
      (t?.classList.toggle("hidden", !e),
      (this.errorMsg = this.errorMsg || this.querySelector(".js-form-error")),
      this.errorMsg && e)
    ) {
      let t =
        "The maximum quantity of this item is already in your cart." === e
          ? "You have added this item to your shopping cart up to the maximum quantity."
          : e;
      this.errorMsg.innerHTML = "";
      (Array.isArray(t) ? t : [t]).forEach((e, t) => {
        t > 0 && this.errorMsg.insertAdjacentHTML("beforeend", "<br>"),
          this.errorMsg.insertAdjacentText("beforeend", e);
      });
    }
  }
  validate() {
    let e = !0;
    return (
      this.querySelectorAll("variant-picker .option-selector").forEach((t) => {
        let i = !0;
        if (
          (t.querySelectorAll(".label__prefix").forEach((e) => e.remove()),
          t
            .querySelectorAll(".label--contains-error")
            .forEach((e) => e.classList.remove("label--contains-error")),
          "listed" === t.dataset.selectorType)
        ) {
          t.querySelector("input").checkValidity() || (i = !1);
        } else {
          t.querySelector('.custom-select .js-option[aria-selected="true"]') ||
            (i = !1);
        }
        if (!i) {
          e = !1;
          const i = t.querySelector(".label");
          if (
            (i.setAttribute("aria-live", "polite"),
            i.classList.add("label--contains-error"),
            i.hasAttribute("is-size-label"))
          )
            return;
          const n = document.createElement("span");
          (n.innerText = `${theme.strings.productsProductChooseA} `),
            (n.className = "label__prefix"),
            i.prepend(n),
            theme.scrollToRevealElement(t);
        }
      }),
      e
    );
  }
};
window.customElements.define("product-form", ProductForm);
class ProductInventory extends HTMLElement {
  constructor() {
    super(), window.initLazyScript(this, this.initLazySection.bind(this));
  }
  initLazySection() {
    (this.threshold = parseInt(this.dataset.threshold, 10)),
      (this.productInventory = this.querySelector(".product-inventory")),
      (this.inventoryNotice = this.querySelector(".product-inventory__status")),
      (this.variantInventory = this.getVariantInventory()),
      this.closest(".js-product").addEventListener(
        "on:variant:change",
        this.handleVariantChange.bind(this)
      );
  }
  getVariantInventory() {
    const e = this.querySelector('[type="application/json"]');
    return this.variantInventory || JSON.parse(e.textContent);
  }
  handleVariantChange(e) {
    this.updateInventory(
      e.detail.variant
        ? this.variantInventory.find((t) => t.id === e.detail.variant.id)
        : null
    );
  }
  updateInventory(e) {
    if (!e) return void (this.productInventory.hidden = !0);
    const t = e.inventory_quantity;
    let i = null;
    (i =
      "always" === this.dataset.showInventoryCount ||
      ("low" === this.dataset.showInventoryCount && t <= this.threshold)
        ? t <= this.threshold
          ? this.dataset.textXLeftLow.replace("[QTY]", t)
          : this.dataset.textXLeftOk.replace("[QTY]", t)
        : t <= this.threshold
        ? this.dataset.textLow
        : this.dataset.textOk),
      this.productInventory.classList.toggle(
        "product-inventory--low",
        t <= this.threshold
      ),
      this.productInventory.classList.toggle(
        "product-inventory--ok",
        t > this.threshold
      ),
      (this.inventoryNotice.innerText = i),
      (this.productInventory.hidden = !1);
  }
}
if (
  (customElements.define("product-inventory", ProductInventory),
  !customElements.get("quantity-wrapper"))
) {
  class e extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));
    }
    handleClick(e) {
      const t = e.target.closest("[data-quantity]");
      if (t) {
        e.preventDefault();
        const i = this.querySelector('[name="quantity"]');
        let n = "up" === t.dataset.quantity ? 1 : -1;
        i.step && (n *= parseInt(i.step, 10)),
          (i.value = Math.max(1, parseInt(i.value, 10) + n)),
          i.dispatchEvent(
            new CustomEvent("change", { bubbles: !0, cancelable: !1 })
          );
      }
    }
  }
  customElements.define("quantity-wrapper", e);
}
"off" !== theme.settings.quickbuyStyle &&
  ((theme.quickbuy = {
    quickbuyResizeObserver: null,
    init: () => {
      (theme.quickbuy.quickbuyResizeObserver = new ResizeObserver((e) => {
        for (let t = 0; t < e.length; t += 1) {
          const i = e[t];
          (i.contentBoxSize || i.contentRect) &&
            theme.quickbuy.debouncedQuickbuyResize(i.target);
        }
      })),
        theme.addDelegateEventListener(
          document,
          "click",
          ".quickbuy-toggle",
          (e, t) => {
            const i = t.href;
            if (window.innerWidth >= 768) {
              e.preventDefault(),
                theme.quickbuy.currentRequestAbortController &&
                  theme.quickbuy.currentRequestAbortController.abort(
                    "Existing request not needed"
                  ),
                (theme.quickbuy.currentRequestAbortController =
                  new AbortController());
              const n = t.closest(".product-block"),
                s = t.closest(".collection-slider");
              let r = null,
                o = null,
                a = null;
              if (s) {
                if (
                  ((a = s.closest(".collection-slider-row")),
                  !a.querySelector(".quickbuy-container"))
                )
                  return;
                o = a.querySelector(".quickbuy-container");
              } else
                theme.quickbuy.setBlockHeights(n),
                  (o = n.querySelector(".quickbuy-container"));
              if (
                ((r = o.querySelector(".inner")),
                n.classList.toggle("expanded"),
                n.classList.contains("expanded"))
              ) {
                if (
                  (o.dispatchEvent(
                    new CustomEvent("on:quickbuy:before-open", { bubbles: !0 })
                  ),
                  s)
                ) {
                  const e = Array.from(
                    s.querySelectorAll(".product-block.expanded")
                  ).filter((e) => e !== n);
                  e.forEach((e) => e.classList.remove("expanded")),
                    0 === e.length && (o.style.height = 0);
                } else
                  [...n.parentElement.children].forEach((e) => {
                    e !== n &&
                      e.classList.contains("expanded") &&
                      theme.quickbuy.contractDetail(e, !0);
                  });
                theme.quickbuy.quickbuyResizeObserver.disconnect(),
                  theme.quickbuy.quickbuyResizeObserver.observe(r),
                  (r.innerHTML = '<div class="loading-spinner"></div>'),
                  fetch(i, {
                    method: "get",
                    signal: theme.quickbuy.currentRequestAbortController.signal,
                  })
                    .then((e) => {
                      if (!e.ok)
                        throw new Error(`HTTP error! Status: ${e.status}`);
                      return e.text();
                    })
                    .then((e) => {
                      const t = document.createElement("template");
                      t.innerHTML = e;
                      const n = t.content
                        .querySelector(".quickbuy-content")
                        .cloneNode(!0);
                      n.querySelectorAll(".more").forEach((e) => {
                        e.href = i;
                      }),
                        n.querySelectorAll(".product-title").forEach((e) => {
                          (e.innerHTML = `<a href="">${e.innerHTML}</a>`),
                            (e.firstElementChild.href = i);
                        }),
                        n.querySelectorAll(".show-gallery").forEach((e) => {
                          e.classList.remove("show-gallery"), (e.href = i);
                        }),
                        n.querySelectorAll(".not-in-quickbuy").forEach((e) => {
                          e.remove();
                        }),
                        n.querySelectorAll(".only-in-quickbuy").forEach((e) => {
                          e.classList.remove("only-in-quickbuy");
                        }),
                        n
                          .querySelectorAll(".sticky-content-container")
                          .forEach((e) => {
                            e.classList.remove("sticky-content-container");
                          }),
                        n
                          .querySelectorAll("pickup-availability")
                          .forEach((e) => {
                            e.remove();
                          }),
                        n
                          .querySelectorAll(
                            'variant-picker[data-update-url="true"]'
                          )
                          .forEach((e) => {
                            e.dataset.updateUrl = !1;
                          }),
                        n
                          .querySelectorAll("noscript")
                          .forEach((e) => e.remove()),
                        n
                          .querySelectorAll(
                            ".media-gallery .main-image carousel-slider"
                          )
                          .forEach((e) => {
                            e.classList.remove("mobile-only");
                          }),
                        n
                          .querySelectorAll(".product-media-collage")
                          .forEach((e) => {
                            e.remove();
                          }),
                        n
                          .querySelectorAll(".media-gallery .thumbnails")
                          .forEach((e) => {
                            e.classList.remove("mobile-only");
                          }),
                        [
                          "media-gallery--layout-carousel-beside",
                          "media-gallery--layout-columns-1",
                          "media-gallery--layout-columns-2",
                          "media-gallery--layout-collage-1",
                          "media-gallery--layout-collage-2",
                        ].forEach((e) => {
                          n.querySelectorAll(`.${e}`).forEach((t) => {
                            t.classList.remove(e),
                              t.classList.add(
                                "media-gallery--layout-carousel-under"
                              );
                          });
                        }),
                        t.content
                          .querySelectorAll(
                            '.section-main-product link[rel="stylesheet"]'
                          )
                          .forEach((e) => {
                            document.querySelector(
                              `link[rel="stylesheet"][href="${e.getAttribute(
                                "href"
                              )}"]`
                            ) ||
                              document.head.insertAdjacentHTML(
                                "beforeend",
                                e.outerHTML
                              );
                          }),
                        t.content
                          .querySelectorAll(".section-main-product script[src]")
                          .forEach((e) => {
                            if (
                              !document.querySelector(
                                `script[src="${e.getAttribute("src")}"]`
                              )
                            ) {
                              const t = document.createElement("script");
                              (t.src = e.getAttribute("src")),
                                (t.defer = "defer"),
                                document.head.appendChild(t);
                            }
                          }),
                        (r.innerHTML = ""),
                        r.appendChild(n),
                        o.dispatchEvent(
                          new CustomEvent("on:quickbuy:after-open", {
                            bubbles: !0,
                          })
                        );
                    })
                    .catch((e) => {
                      console.warn(e);
                    });
                const e = o.querySelector(".close-detail");
                e.removeAttribute("tabindex"),
                  e.removeAttribute("aria-hidden"),
                  e.addEventListener("click", theme.quickbuy.onCloseClick);
                const t = -120 - theme.stickyHeaderHeight();
                s
                  ? window.scrollTo({
                      top: theme.getOffsetTopFromDoc(o) + t,
                      behavior: "smooth",
                    })
                  : (theme.quickbuy.saveProductGridSpacingData(),
                    window.scrollTo({
                      top:
                        parseFloat(
                          n.dataset.qbScrollTo || theme.getOffsetTopFromDoc(o)
                        ) + t,
                      behavior: "smooth",
                    }));
              } else {
                s
                  ? ((o.style.height = "0px"),
                    setTimeout(() => {
                      "0px" === o.style.height && (r.innerHTML = "");
                    }, 1e3 * parseFloat(getComputedStyle(o).transitionDuration)))
                  : theme.quickbuy.contractDetail(n),
                  setTimeout(() => {
                    window.scrollTo({
                      top:
                        theme.getOffsetTopFromDoc(n) -
                        theme.stickyHeaderHeight() -
                        20,
                      behavior: "smooth",
                    });
                  }, 100);
                const e = o.querySelector(".close-detail");
                e.blur(),
                  e.setAttribute("tabindex", "-1"),
                  e.setAttribute("aria-hidden", !0),
                  e.removeEventListener("click", theme.quickbuy.onCloseClick);
              }
            }
          }
        );
    },
    debouncedQuickbuyResizeTimeoutID: -1,
    debouncedQuickbuyResize: (e) => {
      clearTimeout(theme.quickbuy.debouncedQuickbuyResizeTimeoutID),
        (theme.quickbuy.debouncedQuickbuyResizeTimeoutID = setTimeout(() => {
          const t = e.closest(".quickbuy-container"),
            i = t.closest(".product-block");
          if (i && i.classList.contains("expanded")) {
            const n = e.clientHeight;
            (i.style.paddingBottom = `${n + 20}px`),
              (t.style.height = `${n}px`);
          }
          e.childElementCount > 0 && (t.style.height = `${e.clientHeight}px`);
        }, 100));
    },
    contractDetail: (e, t) => {
      theme.quickbuy.quickbuyResizeObserver.disconnect(),
        clearTimeout(theme.quickbuy.debouncedQuickbuyResizeTimeoutID),
        e.classList.remove("expanded");
      const i = e.querySelector(".quickbuy-container");
      t &&
        ((i.style.transitionDuration = "0ms"),
        (e.style.transitionDuration = "0ms")),
        (i.style.height = 0),
        (e.style.paddingBottom = 0);
      const n = 1e3 * parseFloat(getComputedStyle(i).transitionDuration);
      setTimeout(() => {
        "0px" === i.style.height && (i.querySelector(".inner").innerHTML = ""),
          t &&
            ((i.style.transitionDuration = ""),
            (e.style.transitionDuration = ""));
      }, n),
        i.dispatchEvent(
          new CustomEvent("on:quickbuy:after-close", { bubbles: !0 })
        );
    },
    saveProductGridSpacingData: () => {
      document.querySelectorAll(".product-grid").forEach((e) => {
        const t = e.querySelectorAll(".product-block .block-inner");
        if (t.length <= 1) return;
        let i = 0,
          n = 0,
          s = 0;
        const r = parseFloat(getComputedStyle(e).rowGap),
          o = [theme.getOffsetTopFromDoc(t[0])];
        t.forEach((e, t) => {
          e.clientHeight > s && (s = e.clientHeight);
          const a = theme.getOffsetTopFromDoc(e);
          0 === t
            ? (n = a)
            : a > n && ((i += 1), (n = a), o.push(r + s + o[i - 1]), (s = 0)),
            (e.dataset.gridRow = i);
        }),
          t.forEach((e) => {
            e.dataset.qbScrollTo = o[e.dataset.gridRow] + e.clientHeight;
          });
      });
    },
    setBlockHeights: (e) => {
      const t = e.closest(".product-grid");
      if (!t) return;
      let i = 0;
      const n = e.offsetTop,
        s = [...t.querySelectorAll(".product-block")].filter(
          (e) => e.offsetTop === n
        );
      s.forEach((e) => {
        const t = e.querySelector(
          ".block-inner .block-inner-inner"
        ).clientHeight;
        t > i && (i = t);
      }),
        s.forEach((e) => {
          e.querySelector(".block-inner").style.setProperty(
            "--qb-block-height",
            `${i}px`
          );
        });
    },
    onCloseClick: (e) => {
      e.preventDefault(), e.stopPropagation();
      const t = e.target.closest(".collection-slider-row");
      t
        ? t
            .querySelector(".product-block.expanded .quickbuy-toggle")
            .dispatchEvent(
              new CustomEvent("click", { bubbles: !0, cancelable: !0 })
            )
        : e.target
            .closest(".product-block")
            .querySelector(".quickbuy-toggle")
            .dispatchEvent(
              new CustomEvent("click", { bubbles: !0, cancelable: !0 })
            );
    },
  }),
  theme.quickbuy.init());
class CarouselSlider extends HTMLElement {
  constructor() {
    super(),
      (this.slides = [...this.querySelectorAll(".slider__item:not([hidden])")]),
      this.slides.length < 2
        ? this.setCarouselState(!1)
        : window.initLazyScript(this, this.init.bind(this));
  }
  init() {
    (this.slider = this.querySelector(".slider")),
      (this.grid = this.querySelector(".slider__grid")),
      (this.nav = this.querySelector(".slider-nav")),
      (this.rtl = "rtl" === document.dir),
      this.nav &&
        ((this.prevBtn = this.querySelector('button[name="prev"]')),
        (this.nextBtn = this.querySelector('button[name="next"]'))),
      this.initSlider(),
      window.addEventListener(
        "on:debounced-resize",
        this.handleResize.bind(this)
      ),
      this.setAttribute("loaded", "");
  }
  initSlider() {
  const firstSlide = this.slides[0];
  const secondSlide = this.slides[1];
  const gridWidth = this.grid.clientWidth;
  const firstSlideOffset = this.getWindowOffset(firstSlide);
  const secondSlideOffset = this.getWindowOffset(secondSlide);
  const firstSlideWidth = firstSlide.clientWidth;

  this.gridWidth = gridWidth;
  this.slideSpan = secondSlideOffset - firstSlideOffset;
  this.currentIndex = Math.round(this.slider.scrollLeft / this.slideSpan) || 0;
  this.slideGap = this.slideSpan - firstSlideWidth;

  this.slidesPerPage = Math.round((gridWidth + this.slideGap) / this.slideSpan);
  this.slidesToScroll =
    theme.settings.sliderItemsPerNav === "page" ? this.slidesPerPage : 1;

  this.totalPages = this.slides.length - this.slidesPerPage + 1;
  this.setCarouselState(this.totalPages > 1);

  if (this.dataset.dynamicHeight === "true") {
    this.updateDynamicHeight();
  }

  this.addListeners();
  this.sliderStart = this.getWindowOffset(this.slider) || (this.slider.clientWidth - gridWidth) / 2;
  this.sliderEnd = this.sliderStart + gridWidth;

  if (this.totalPages > 1) {
    if (window.matchMedia("(pointer: fine)").matches) {
      this.slider.classList.add("is-grabbable");
    }
    if (this.nav) this.setButtonStates();
  }
}

  refresh() {
    this.hasAttribute("loaded") &&
      (this.removeListeners(),
      this.style.removeProperty("--current-slide-height")),
      (this.slides = [...this.querySelectorAll(".slider__item:not([hidden])")]),
      this.slides.length < 2 ? this.setCarouselState(!1) : this.init();
  }
  addListeners() {
    (this.scrollHandler = debounce(this.handleScroll.bind(this), 100)),
      this.slider.addEventListener("scroll", this.scrollHandler),
      this.nav &&
        ((this.navClickHandler = this.handleNavClick.bind(this)),
        this.nav.addEventListener("click", this.navClickHandler)),
      window.matchMedia("(pointer: fine)").matches &&
        ((this.mousedownHandler = this.handleMousedown.bind(this)),
        (this.mouseupHandler = this.handleMouseup.bind(this)),
        (this.mousemoveHandler = this.handleMousemove.bind(this)),
        this.slider.addEventListener("mousedown", this.mousedownHandler),
        this.slider.addEventListener("mouseup", this.mouseupHandler),
        this.slider.addEventListener("mouseleave", this.mouseupHandler),
        this.slider.addEventListener("mousemove", this.mousemoveHandler),
        this.slider.addEventListener("dragstart", (e) => {
          e.preventDefault();
        }));
  }
  removeListeners() {
    this.slider.removeEventListener("scroll", this.scrollHandler),
      this.nav && this.nav.removeEventListener("click", this.navClickHandler),
      window.matchMedia("(pointer: fine)").matches &&
        (this.slider.removeEventListener("mousedown", this.mousedownHandler),
        this.slider.removeEventListener("mouseup", this.mouseupHandler),
        this.slider.removeEventListener("mouseleave", this.mouseupHandler),
        this.slider.removeEventListener("mousemove", this.mousemoveHandler));
  }
handleScroll() {
  if (this._scrollRaf) return; // prevent multiple queued frames

  this._scrollRaf = requestAnimationFrame(() => {
    this._scrollRaf = null;

    const newGridWidth = this.grid.clientWidth;
    if (this.gridWidth !== newGridWidth) {
      this.handleResize();
    }

    const prevIndex = this.currentIndex;
    this.currentIndex = Math.round(Math.abs(this.slider.scrollLeft) / this.slideSpan);

    if (this.nav) this.setButtonStates();

    if (this.dataset.dynamicHeight === "true") this.updateDynamicHeight();

    if (this.dataset.dispatchEvents === "true" && prevIndex !== this.currentIndex) {
      this.dispatchEvent(
        new CustomEvent("on:carousel-slider:select", {
          bubbles: true,
          detail: {
            index: this.currentIndex,
            slide: this.slides[this.currentIndex],
          },
        })
      );
    }
  });
}

  handleMousedown(e) {
    (this.mousedown = !0),
      (this.mousemoved = !1),
      (this.startX = e.pageX - this.sliderStart),
      (this.scrollPos = this.slider.scrollLeft),
      this.slider.classList.add("is-grabbing");
  }
  handleMouseup(e) {
    (this.mousedown = !1),
      this.slider.classList.remove("is-grabbing"),
      this.mousemoved &&
        (e.preventDefault(), this.slider.classList.remove("is-dragging"));
  }
  handleMousemove(e) {
    if (!this.mousedown) return;
    if (e.target.closest("vr-media-block")) return;
    console.log("evt.target", e.target), e.preventDefault();
    const t = e.pageX - this.sliderStart;
    this.slider.scrollTo({
      left: this.scrollPos - (t - this.startX),
      behavior: "instant",
    }),
      (this.mousemoved = !0),
      this.slider.classList.add("is-dragging");
  }
  handleNavClick(e) {
    e.target.matches(".slider-nav__btn") &&
      (("next" === e.target.name && !this.rtl) ||
      ("prev" === e.target.name && this.rtl)
        ? (this.scrollPos =
            this.slider.scrollLeft + this.slidesToScroll * this.slideSpan)
        : (this.scrollPos =
            this.slider.scrollLeft - this.slidesToScroll * this.slideSpan),
      this.slider.scrollTo({ left: this.scrollPos, behavior: "smooth" }));
  }
  handleResize() {
    this.nav && this.removeListeners(), this.initSlider();
  }
  scrollToElement(e, t) {
    this.getSlideVisibility(e) ||
      ((this.scrollPos = e.offsetLeft),
      this.slider.scrollTo({ left: this.scrollPos, behavior: t || "smooth" }));
  }
  updateDynamicHeight() {
  if (!this.slides || !this.slides[this.currentIndex]) return;

  const slideContent = this.slides[this.currentIndex].firstElementChild;
  if (!slideContent) return;

  const height = slideContent.clientHeight;

  // Use requestAnimationFrame to avoid forced reflow
  requestAnimationFrame(() => {
    this.style.setProperty("--current-slide-height", `${height}px`);
  });
}

  getWindowOffset(e) {
    return this.rtl
      ? window.innerWidth - e.getBoundingClientRect().right
      : e.getBoundingClientRect().left;
  }
  getSlideVisibility(e) {
    const t = this.getWindowOffset(e),
      i = Math.floor(t + this.slides[0].clientWidth);
    return t >= this.sliderStart && i <= this.sliderEnd;
  }
  setCarouselState(e) {
    e
      ? (this.removeAttribute("inactive"),
        this.gridWidth !== this.grid.clientWidth &&
          this.handleBreakpointChange())
      : this.setAttribute("inactive", "");
  }
  setButtonStates() {
    (this.prevBtn.disabled =
      this.getSlideVisibility(this.slides[0]) && 0 === this.slider.scrollLeft),
      (this.nextBtn.disabled = this.getSlideVisibility(
        this.slides[this.slides.length - 1]
      ));
  }
}
customElements.define("carousel-slider", CarouselSlider);
const TermsAgreement = class extends HTMLElement {
  connectedCallback() {
    this.delegatedEvent = theme.addDelegateEventListener(
      document,
      "click",
      '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]',
      this.handleFormSubmittingEvent.bind(this)
    );
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.delegatedEvent);
  }
  handleFormSubmittingEvent(e) {
    this.querySelector("input:checked") ||
      (e.preventDefault(),
      theme.showQuickPopup(
        theme.strings.cartTermsConfirmation,
        this.querySelector('[type="checkbox"]')
      ));
  }
};
window.customElements.define("terms-agreement", TermsAgreement);
const ToggleTarget = class extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", this.toggleOpen.bind(this)),
      this.addEventListener("keyup", this.handleKeyUp.bind(this)),
      this.dataset.toggleCloseLabel &&
        (this.dataset.toggleOpenLabel = this.innerHTML);
  }
  handleKeyUp(e) {
    "Enter" === e.key && this.toggleOpen(e);
  }
  toggleOpen(e) {
  e.preventDefault();

  const target = document.querySelector(this.dataset.toggleTarget);
  if (!target) return;

  const container = target.querySelector(".toggle-target-container");
  if (!container) return;

  const isOpen = !target.classList.contains("toggle-target--hidden");
  const duration =
    parseFloat(getComputedStyle(target).transitionDuration) * 1000;

  if (target.classList.contains("toggle-target--in-transition")) return;

  const setHeightOpacity = (height, opacity) => {
    target.style.height = height;
    target.style.opacity = opacity;
  };

  target.classList.add("toggle-target--in-transition");

  if (isOpen) {
    this.classList.add("toggle-target-toggler--is-hidden");
    if (this.dataset.toggleOpenLabel) this.innerHTML = this.dataset.toggleOpenLabel;

    const height = `${container.clientHeight}px`;
    setHeightOpacity(height, 1);

    requestAnimationFrame(() => {
      setHeightOpacity("0px", 0);

      setTimeout(() => {
        target.classList.add("toggle-target--hidden");
        target.classList.remove("toggle-target--in-transition", "toggle-target--hiding");
        target.style.height = "";
        target.style.opacity = "";
      }, duration);
    });
  } else {
    this.classList.remove("toggle-target-toggler--is-hidden");
    if (this.dataset.toggleCloseLabel) this.innerHTML = this.dataset.toggleCloseLabel;

    target.classList.remove("toggle-target--hidden");
    target.style.display = "block";
    setHeightOpacity("0px", 0);

    requestAnimationFrame(() => {
      const height = `${container.clientHeight}px`;
      setHeightOpacity(height, 1);

      setTimeout(() => {
        target.classList.remove("toggle-target--in-transition", "toggle-target--revealing");
        target.style.height = "";
        target.style.opacity = "";
        target.style.display = "";
      }, duration);
    });
  }
}

};
window.customElements.define("toggle-target", ToggleTarget);
class VariantContent extends HTMLElement {
  constructor() {
    super(),
      this.childElementCount > 0 &&
        this.closest(".js-product").addEventListener(
          "on:variant:change",
          this.handleVariantChange.bind(this)
        );
  }
  handleVariantChange(e) {
    [...this.childNodes]
      .filter((e) => "SCRIPT" !== e.tagName)
      .forEach((e) => e.remove()),
      this.querySelectorAll(":not(script)").forEach((e) => e.remove());
    const t = this.querySelector(
      `[data-variant="${e.detail.variant ? e.detail.variant.id : ""}"]`
    );
    t && this.insertAdjacentHTML("beforeend", t.innerHTML);
  }
}
customElements.define("variant-content", VariantContent);
const AnnouncementBar = class extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.announcements = this.querySelectorAll(".announcement")),
      this.announcements.length > 1)
    ) {
      (this.backgrounds = Array.from(
        this.querySelectorAll(".announcement-bg")
      )),
        (this.changeDelay = 7e3),
        (this.currentAnnouncement = 0),
        (this.announcementInterval = null);
      const e = this.querySelector(".announcement-bar__middle");
      let t, i;
      e.addEventListener("focusin", this.playAnnouncements.bind(this)),
        e.addEventListener("focusout", this.playAnnouncements.bind(this)),
        this.querySelector(".announcement-button--previous").addEventListener(
          "click",
          () => {
            this.classList.remove("scroll-ltr"),
              this.classList.add("scroll-rtl"),
              this.classList.add("animating"),
              this.pauseAnnouncements(),
              this.playAnnouncements(),
              this.previousAnnouncement(),
              clearTimeout(t),
              (t = setTimeout(() => {
                this.classList.remove("animating");
              }, 500));
          }
        ),
        this.querySelector(".announcement-button--next").addEventListener(
          "click",
          () => {
            this.classList.remove("scroll-rtl"),
              this.classList.add("scroll-ltr"),
              this.pauseAnnouncements(),
              this.playAnnouncements(),
              this.nextAnnouncement(),
              clearTimeout(i),
              (i = setTimeout(() => {
                this.classList.add("scroll-rtl"),
                  this.classList.remove("scroll-ltr");
              }, 500));
          }
        ),
        (this.observer = new IntersectionObserver(
          this.handleIntersect.bind(this)
        )),
        this.observer.observe(this);
    }
  }
  handleIntersect(e) {
    e.forEach((e) => {
      e.target === this && (e.isIntersecting, this.playAnnouncements());
    });
  }
  playAnnouncements() {
    this.announcements.length > 1 &&
      !this.announcementInterval &&
      (this.announcementInterval = setInterval(() => {
        this.setCurrentAnnouncement(this.currentAnnouncement + 1);
      }, this.changeDelay));
  }
  pauseAnnouncements() {
    this.announcementInterval &&
      (clearInterval(this.announcementInterval),
      (this.announcementInterval = null));
  }
  setCurrentAnnouncement(e) {
    const t = this.announcements.length,
      i = ((e % t) + t) % t;
    if (this.currentAnnouncement === i) return;
    (this.currentAnnouncement = i),
      this.announcements.forEach((e, t) => {
        const i = this.backgrounds.find(
            (e) => e.dataset.index === t.toString()
          ),
          n = t === this.currentAnnouncement;
        e.classList.toggle("announcement--inactive", !n),
          n ||
            (e.classList.add("animating-announcement--inactive"),
            setTimeout(() => {
              e.classList.remove("animating-announcement--inactive");
            }, 300)),
          i && i.classList.toggle("is-active", n);
      });
    const n = this.announcements[this.currentAnnouncement];
    ["--heading-color", "--text-color", "--link-color"].forEach((e) => {
      const t = n.style.getPropertyValue(e);
      t && this.style.setProperty(e, t);
    });
  }
  previousAnnouncement() {
    this.setCurrentAnnouncement(this.currentAnnouncement - 1);
  }
  nextAnnouncement() {
    this.setCurrentAnnouncement(this.currentAnnouncement + 1);
  }
};
window.customElements.define("announcement-bar", AnnouncementBar);
const ImageWithTextOverlay = class extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.fullHeightContainer = this.classList.contains("height--full")
        ? this
        : this.querySelector(".height--full")),
      this.fullHeightContainer)
    ) {
      if (this.closest(".shopify-section").previousElementSibling) return;
      const e = document.querySelector(".pageheader");
      if (!e)
        return void this.fullHeightContainer.classList.add(
          "height--full-ignore-header-height"
        );
      const t = theme.getOffsetTopFromDoc(this);
      if (theme.getOffsetTopFromDoc(e) - 5 > t)
        return void this.fullHeightContainer.classList.add(
          "height--full-ignore-header-height"
        );
      this.fullHeightContainer.classList.add(
        "height--full-minus-header-height"
      ),
        this.checkForHeaderHeightSubtraction();
      const i = debounce(this.checkForHeaderHeightSubtraction.bind(this), 300);
      (this.resizeObserver = new ResizeObserver((e) => {
        for (let t = 0; t < e.length; t += 1) {
          const n = e[t];
          (n.contentBoxSize || n.contentRect) && i();
        }
      })),
        this.resizeObserver.observe(this);
    }
  }
  checkForHeaderHeightSubtraction() {
    let e = window.innerHeight;
    document.querySelector(".pageheader--transparent-permitted") &&
    !this.closest(".shopify-section").previousElementSibling
      ? document
          .querySelectorAll(
            ".section-store-messages, .section-announcement-bar"
          )
          .forEach((t) => {
            e -= t.clientHeight;
          })
      : (e -= document.querySelector(".section-header").clientHeight),
      this.fullHeightContainer.style.setProperty("--image-height", `${e}px`);
  }
};
window.customElements.define("image-with-text-overlay", ImageWithTextOverlay);
const PageHeader = class extends HTMLElement {
  constructor() {
    super(),
      this.querySelector(".show-search-link") &&
        theme.addDelegateEventListener(
          this,
          "click",
          ".show-search-link",
          (e) => {
            e.preventDefault(),
              document
                .querySelector(
                  ".boost-sd__instant-search-container-mobile .boost-sd__search-bar-wrapper"
                )
                ?.classList.remove("boost-sd__g-hide");
          }
        ),
      theme.inlineNavigationCheck(),
      "drawer" === theme.settings.cartType &&
        document.querySelector(".js-cart-drawer") &&
        this.querySelector(".cart-link") &&
        theme.addDelegateEventListener(this, "click", ".cart-link", (e) => {
          e.preventDefault(),
            document.querySelector(".js-cart-drawer").open(e.target);
        }),
      window.Shopify.designMode &&
        document.body.classList.contains("reveal-mobile-nav") &&
        theme.openMobileNav(),
      (this.preloadOnFirstInteraction = () => {
        theme.manuallyLoadImages(this),
          this.removeEventListener(
            "mouseenter",
            this.preloadOnFirstInteraction
          ),
          this.removeEventListener(
            "touchstart",
            this.preloadOnFirstInteraction
          ),
          this.removeEventListener("keydown", this.preloadOnFirstInteraction);
      }),
      this.addEventListener("mouseenter", this.preloadOnFirstInteraction),
      this.addEventListener("touchstart", this.preloadOnFirstInteraction),
      this.addEventListener("keydown", this.preloadOnFirstInteraction),
      setTimeout(() => this.preloadOnFirstInteraction(), 5e3);
  }
  connectedCallback() {
    (this.section = document.querySelector(".section-header")),
      (this.transparentPageheader = document.querySelector(
        ".pageheader--transparent-permitted"
      )),
      this.setTransparency(),
      this.setSticky(),
      this.setHeaderHeightProperty(),
      window.addEventListener("scroll", this.afterScroll.bind(this)),
      (this.refreshHeader = () => {
        fetch(`${window.location.origin}?sections=header`)
          .then((e) => e.json())
          .then((e) => {
            const t = document.createElement("template");
            t.innerHTML = e.header;
            const i = [
              "#pageheader .logo-area__right__inner .cart-link .cart-link__icon .cart-link__count",
            ];
            for (let e = 0; e < i.length; e += 1) {
              const n = t.content.querySelector(i[e]);
              if(this.querySelector(i[e]) && n){
              this.querySelector(i[e]).innerHTML = n.innerHTML;
              }
            }
          });
      }),
      document.addEventListener("on:cart:change", this.refreshHeader);
    const e = debounce(this.afterResize.bind(this), 300);
    (this.resizeObserver = new ResizeObserver((t) => {
      for (let i = 0; i < t.length; i += 1) {
        const n = t[i];
        (n.contentBoxSize || n.contentRect) && e();
      }
    })),
      this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this.resizeObserver.disconnect(),
      document.removeEventListener("on:cart:change", this.refreshHeader);
  }
  afterScroll() {
    this.setTransparency();
  }
  afterResize() {
    theme.inlineNavigationCheck && theme.inlineNavigationCheck(),
      this.setSticky(),
      this.setHeaderHeightProperty();
  }
  setTransparency() {
    if (this.transparentPageheader) {
      const e = document.querySelector(".section-announcement-bar"),
        t = e ? e.offsetTop + e.clientHeight : 0;
      !this.isSticky || window.scrollY <= t
        ? this.transparentPageheader.classList.add("pageheader--transparent")
        : this.transparentPageheader.classList.remove(
            "pageheader--transparent"
          );
    }
  }
  setSticky() {
    this.isSticky =
      "sticky" === getComputedStyle(this.section).position ||
      "-webkit-sticky" === getComputedStyle(this.section).position;
  }
 setHeaderHeightProperty() {
  if (!this.section) return;

  const headerHeight = Math.ceil(this.section.clientHeight);
  const stickyHeight = this.isSticky ? headerHeight : 0;

  // Cache previous values to avoid unnecessary style writes
  if (this._lastHeaderHeight !== headerHeight) {
    document.documentElement.style.setProperty(
      "--theme-header-height",
      `${headerHeight}px`
    );
    this._lastHeaderHeight = headerHeight;
  }

  if (this._lastStickyHeight !== stickyHeight) {
    document.documentElement.style.setProperty(
      "--theme-sticky-header-height",
      `${stickyHeight}px`
    );
    this._lastStickyHeight = stickyHeight;
  }
}

  updateFromCartChange(e) {
    const t = ".cart-link.header-link-icon",
      i = document.createElement("template");
    i.innerHTML = e;
    const n = this.querySelector(t);
    n && (n.innerHTML = i.content.querySelector(t).innerHTML);
  }
};
window.customElements.define("page-header", PageHeader);
const RelatedCollectionLinkButtons = class extends HTMLElement {
  constructor() {
    super();
    const e = debounce(this.truncateButtons.bind(this), 300);
    (this.resizeObserver = new ResizeObserver((t) => {
      for (let i = 0; i < t.length; i += 1) {
        const n = t[i];
        (n.contentBoxSize || n.contentRect) && e();
      }
    })),
      this.resizeObserver.observe(this),
      this.truncateButtons();
  }
  truncateButtons() {
    if ("flex" === getComputedStyle(this).display) {
      const e = 4,
        t = this.querySelectorAll(".btn");
      if (
        t.length > e &&
        !this.querySelector(".related-collection-links__expander")
      ) {
        Array.from(t)
          .slice(e - 1)
          .forEach((e) => e.classList.add("hidden"));
        const i = document.createElement("a");
        (i.className = "btn btn--tertiary related-collection-links__expander"),
          (i.href = "#"),
          (i.innerText = this.dataset.expanderBtnText),
          i.addEventListener("click", (e) => {
            e.preventDefault(),
              this.resizeObserver.disconnect(),
              [...e.currentTarget.parentElement.children].forEach((e) =>
                e.classList.remove("hidden")
              ),
              e.currentTarget.remove();
          }),
          this.insertAdjacentElement("beforeend", i);
      }
    } else {
      const e = this.querySelector(".related-collection-links__expander");
      e &&
        ([...e.parentElement.children].forEach((e) =>
          e.classList.remove("hidden")
        ),
        e.remove());
    }
  }
};
window.customElements.define(
  "related-collection-link-buttons",
  RelatedCollectionLinkButtons
),
  (window.initLazyScript = initLazyScript),
  theme.Shopify || (theme.Shopify = {});
try {
  theme.Shopify.features = JSON.parse(
    document.documentElement.querySelector("#shopify-features").textContent
  );
} catch (e) {
  theme.Shopify.features = {};
}
document.addEventListener("DOMContentLoaded", () => {
  const e = (e) => {
    const t = "A" === e.target.tagName ? e.target : e.target.closest("a");
    if (
      t &&
      t.getAttribute("href") &&
      t.getAttribute("href").length > 1 &&
      "#" === t.getAttribute("href")[0]
    ) {
      const i = document.querySelector(t.getAttribute("href"));
      i &&
        i.offsetParent &&
        (e.preventDefault(), theme.scrollToRevealElement(i));
    }
  };
  theme.settings.internalLinksSmoothScroll &&
    document.addEventListener("click", e);
  const t = (i) => {
    "Tab" === i.code &&
      (document.body.classList.add("tab-used"),
      document.removeEventListener("keydown", t),
      document.removeEventListener("click", e));
  };
  document.addEventListener("keydown", t),
    theme.settings.externalLinksNewTab &&
      document.addEventListener("click", (e) => {
        const t = "A" === e.target.tagName ? e.target : e.target.closest("a");
        t &&
          t.href &&
          "A" === t.tagName &&
          window.location.hostname !== new URL(t.href).hostname &&
          (t.target = "_blank");
      }),
    theme.addDelegateEventListener(
      document,
      "click",
      ".mobile-nav-toggle",
      (e) => {
        e.preventDefault(),
          document.body.classList.contains("enable-mobile-nav-transition")
            ? (document.body.classList.remove(
                "reveal-mobile-nav",
                "reveal-mobile-nav--revealed"
              ),
              document.querySelectorAll(".navigation__item")?.forEach((e) => {
                e.classList.remove("navigation__item--open");
              }),
              document
                .querySelector(".mobile-navigation-drawer")
                ?.classList.remove("mobile-navigation-drawer--child-open"),
              document.body.classList.remove("show-search"),
              setTimeout(() => {
                document.body.classList.remove("enable-mobile-nav-transition");
              }, 750),
              (document
                .querySelector(".mobile-navigation-drawer")
                .querySelector(".mobile-nav-title").innerText = "Menu"))
            : ((document
                .querySelector(".mobile-navigation-drawer")
                .querySelector(".mobile-nav-title").innerText = "Menu"),
              theme.openMobileNav());
      }
    ),
    (theme.openMobileNav = () => {
      document.body.classList.add("enable-mobile-nav-transition"),
        setTimeout(() => {
          document.body.classList.add("reveal-mobile-nav");
          const e = getComputedStyle(
              document.querySelector(
                ".mobile-navigation-drawer .navigation__tier-1 > .navigation__item > .navigation__link"
              )
            ),
            t =
              parseFloat(e.transitionDelay.split(",")[0]) +
              parseFloat(e.transitionDuration.split(",")[0]);
          setTimeout(() => {
            document.body.classList.add("reveal-mobile-nav--revealed");
          }, 1e3 * t),
            theme.manuallyLoadImages(
              document.querySelector(".mobile-navigation-drawer")
            );
        }, 10);
    });
  const i = document.querySelector(".page-shade");
  i &&
    i.addEventListener("click", (e) => {
      e.preventDefault(),
        document.body.classList.remove("reveal-mobile-nav", "show-search"),
        setTimeout(() => {
          document.body.classList.remove("enable-mobile-nav-transition");
        }, 750);
    });
}),
  (window.onpageshow = () => {
    fetch(`${theme.routes.cart}.js`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((e) => {
        if (!e.ok) throw new Error(`HTTP error! Status: ${e.status}`);
        return e.json();
      })
      .then(async (e) => {
        const { items: t } = e,
          i = t.map((e) => `${e.key}|${e.quantity}`).join(","),
          n = new TextEncoder().encode(i),
          s = await crypto.subtle.digest("SHA-256", n);
        Array.from(new Uint8Array(s))
          .map((e) => e.toString(16).padStart(2, "0"))
          .join("")
          .toString() !== document.querySelector(".cart-link").dataset.hash &&
          document.dispatchEvent(
            new CustomEvent("on:cart:change", { bubbles: !0, cancelable: !1 })
          );
      })
      .catch((e) => {
        console.log(e.message);
      }),
      document.addEventListener("click", function (e) {
        if (e.target.matches("[data-tab]") || e.target.closest("[data-tab]")) {
          const t = e.target.matches("[data-tab]")
              ? e.target
              : e.target.closest("[data-tab]"),
            i = t.closest("section"),
            n = t.getAttribute("data-tab");
          i
            .querySelectorAll("[data-tab-content]")
            ?.forEach((e) => e.classList.remove("active")),
            i
              .querySelectorAll("[data-tab]")
              ?.forEach((e) => e.classList.remove("active")),
            i
              .querySelector('[data-tab-content="' + n + '"]')
              ?.classList.add("active"),
            t.classList.add("active");
        }
      }),
      (window.copyShareLink = function (e) {
        const t = e.href;
        navigator.clipboard
          .writeText(t)
          .then(() => {
            alert("Link copied to clipboard!");
          })
          .catch((e) => {
            console.error("Error copying link:", e),
              alert("Failed to copy the link.");
          });
      });
    class e extends HTMLElement {
      constructor() {
        super(), (this.grid = this.querySelector(".recent-items-grid"));
      }
      connectedCallback() {
        this.render();
      }
      getProductHandles() {
        return JSON.parse(localStorage.getItem("recently") || "[]").join(",");
      }
      async render() {
        const e = this.getProductHandles();
        if (!e) return;
        const t = `/collections/all?view=recently-view&products=${e}`;
        try {
          const e = await fetch(t);
          if (!e.ok)
            throw new Error("Failed to fetch recently viewed products");
          const i = await e.text();
          (this.grid.innerHTML = i), this.classList.remove("hidden");
        } catch (e) {
          console.error(e),
            this.classList.add("hidden"),
            (this.grid.innerHTML =
              "<p>Unable to load recently viewed products.</p>");
        }
      }
    }
    if (
      (customElements.define("recently-viewed-items", e),
      (window.removeRecentSearch = function (e, t) {
        const i = JSON.parse(
          localStorage.getItem("boostPFSRecentSearches") || "[]"
        ).filter((e) => e.title !== t);
        localStorage.setItem("boostPFSRecentSearches", JSON.stringify(i)),
          e.closest("li").remove();
      }),
      (window.removeAllRecentSearch = function (e) {
        localStorage.setItem("boostPFSRecentSearches", []),
          e.closest(".boost-sd__suggestion-queries-group").remove();
      }),
      // document.querySelectorAll(".size-chart-table-wrapper").forEach((e) => {
      //   e.addEventListener("click", function (e) {
      //     if (e.target.matches("th")) {
      //       const t = e.target.closest("table"),
      //         i = Array.from(e.target.parentNode.children),
      //         n = i.findIndex((t) => t === e.target);
      //       i.forEach((e) => e.classList.remove("active")),
      //         e.target.classList.add("active");
      //       t.querySelectorAll("tbody tr").forEach((e) => {
      //         const t = Array.from(e.children);
      //         t.forEach((e) => e.classList.remove("active")),
      //           t[n] && t[n].classList.add("active");
      //       });
      //     }
      //   });
      // }),
      !customElements.get("swymcs-wishlist-button"))
    ) {
      class e extends HTMLElement {
        constructor() {
          super(),
            window.SwymCallbacks || (window.SwymCallbacks = []),
            window.SwymCallbacks.push(this.initializeSwymButton.bind(this));
        }
        async initializeSwymButton(e) {
          var t = this;
          (this.elements = {
            wishlistButton: t.querySelector("button"),
            unfilledState: t.querySelector("#swymUnfilled"),
            filledState: t.querySelector("#swymFilled"),
          }),
            this.elements.wishlistButton.addEventListener("click", () => {
              let {
                  epi: t,
                  empi: i,
                  du: n,
                } = this.elements.wishlistButton.dataset,
                s = {
                  epi: isNaN(t) ? t : Number(t),
                  empi: isNaN(i) ? i : Number(i),
                  du: n,
                };
              console.log("Swym Wishlist Button Clicked", s),
                this.elements.wishlistButton.classList.contains(
                  "swym-added-custom"
                )
                  ? e?.api.addToWishListt(s)
                  : e?.api.addToWishList(s);
            });
        }
      }
      customElements.define("swymcs-wishlist-button", e);
    }
    document.dispatchEvent(new CustomEvent("swym:cart-loaded")),
      window.SwymCallbacks || (window.SwymCallbacks = []),
      window.SwymCallbacks.push(function (e) {
        document.addEventListener("swym:cart-loaded", function () {
          _swat?.initializeActionButtons("cart-drawer");
        });
      }),
      (window.addToCartNotification = function (e) {
        const t = `\n    <div class="add-to-cart-notify-wrapper"> \n  <div class="notify-icon-add-to-cart">\n    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0303 8.03033C15.3232 7.73744 15.3232 7.26256 15.0303 6.96967C14.7374 6.67678 14.2626 6.67678 13.9697 6.96967L8.5 12.4393L6.53033 10.4697C6.23744 10.1768 5.76256 10.1768 5.46967 10.4697C5.17678 10.7626 5.17678 11.2374 5.46967 11.5303L7.61612 13.6768C8.10427 14.1649 8.89573 14.1649 9.38388 13.6768L15.0303 8.03033Z" fill="#FBFBF9"/>\n</svg>\n  </div>\n  <div class="add-to-cart-notify">\n    <div class="add-to-cart-notify__content">\n      <p class="add-to-cart-notify__text">Item added to cart</p> \n      <p class="product-title-add-notify">${e}</p>\n      <a href="${theme.routes.cart}" onclick="event.preventDefault(); document.querySelector('.js-cart-drawer')?.open()" class="link add-to-cart-notify__button">View Cart</a>\n    </div>\n  </div>\n  <button class="notify-close-add-to-cart">\n   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">\n  <g clip-path="url(#clip0_3453_76214)">\n    <path d="M13.4701 1.47206C13.7305 1.21171 13.7305 0.789596 13.4701 0.529247C13.2098 0.268897 12.7876 0.268897 12.5273 0.529247L6.9987 6.05784L1.4701 0.529247C1.20975 0.268897 0.787644 0.268897 0.527294 0.529247C0.266945 0.789596 0.266945 1.21171 0.527294 1.47206L6.05589 7.00065L0.527293 12.5292C0.266944 12.7896 0.266944 13.2117 0.527293 13.4721C0.787644 13.7324 1.20975 13.7324 1.4701 13.4721L6.9987 7.94346L12.5273 13.4721C12.7876 13.7324 13.2098 13.7324 13.4701 13.4721C13.7305 13.2117 13.7305 12.7896 13.4701 12.5292L7.94151 7.00065L13.4701 1.47206Z" fill="#FBFBF9"/>\n  </g>\n  <defs>\n    <clipPath id="clip0_3453_76214">\n      <rect width="13.3333" height="13.3333" fill="white" transform="translate(0.332031 0.333984)"/>\n    </clipPath>\n  </defs>\n</svg>\n  </button>\n</div>\n    `,
          i = document.createElement("div");
        i.innerHTML = t;
        const n = i.firstElementChild;
        document.body.appendChild(n),
          setTimeout(() => {
            n.remove();
          }, 5e3);
      }),
      document.addEventListener("click", function (e) {
        (e.target.matches(".notify-close-add-to-cart") ||
          e.target.closest(".notify-close-add-to-cart")) &&
          e.target.closest(".add-to-cart-notify-wrapper")?.remove(),
          (e.target.matches(".form-error-close-btn") ||
            e.target.closest(".form-error-close-btn")) &&
            e.target
              .closest(".product-form-error-wrapper")
              ?.classList.add("hidden");
      }),
      (window.removeItemNotification = function (e, t) {
        const i = `\n    <div class="cart-item-remove-notify">\n  <span class="remove_icon-info">\n    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">\n  <g clip-path="url(#clip0_4445_41123)">\n    <mask id="path-1-inside-1_4445_41123" fill="white">\n      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 8.33C10.4142 8.33 10.75 8.66579 10.75 9.08V14.95C10.75 15.3642 10.4142 15.7 10 15.7C9.58581 15.7 9.25002 15.3642 9.25002 14.95V9.08C9.25002 8.66579 9.58581 8.33 10 8.33ZM10 5.25C10.4142 5.25 10.75 5.58579 10.75 6V6.01C10.75 6.42421 10.4142 6.76 10 6.76C9.58579 6.76 9.25 6.42421 9.25 6.01V6C9.25 5.58579 9.58579 5.25 10 5.25ZM10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"/>\n    </mask>\n    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 8.33C10.4142 8.33 10.75 8.66579 10.75 9.08V14.95C10.75 15.3642 10.4142 15.7 10 15.7C9.58581 15.7 9.25002 15.3642 9.25002 14.95V9.08C9.25002 8.66579 9.58581 8.33 10 8.33ZM10 5.25C10.4142 5.25 10.75 5.58579 10.75 6V6.01C10.75 6.42421 10.4142 6.76 10 6.76C9.58579 6.76 9.25 6.42421 9.25 6.01V6C9.25 5.58579 9.58579 5.25 10 5.25ZM10 18.5C14.6944 18.5 18.5 14.6944 18.5 10C18.5 5.30558 14.6944 1.5 10 1.5C5.30558 1.5 1.5 5.30558 1.5 10C1.5 14.6944 5.30558 18.5 10 18.5ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z" fill="#fff"/>\n    <path d="M10.75 9.08H12.25C12.25 7.83736 11.2427 6.83 10 6.83V8.33V9.83C9.5858 9.83 9.25002 9.49421 9.25002 9.08H10.75ZM10.75 14.95H12.25V9.08H10.75H9.25002V14.95H10.75ZM10 15.7V17.2C11.2427 17.2 12.25 16.1926 12.25 14.95H10.75H9.25002C9.25002 14.5358 9.5858 14.2 10 14.2V15.7ZM9.25002 14.95H7.75002C7.75002 16.1926 8.75738 17.2 10 17.2V15.7V14.2C10.4142 14.2 10.75 14.5358 10.75 14.95H9.25002ZM9.25002 9.08H7.75002V14.95H9.25002H10.75V9.08H9.25002ZM10 8.33V6.83C8.75738 6.83 7.75002 7.83736 7.75002 9.08H9.25002H10.75C10.75 9.49421 10.4142 9.83 10 9.83V8.33ZM10.75 6H12.25C12.25 4.75736 11.2426 3.75 10 3.75V5.25V6.75C9.58579 6.75 9.25 6.41421 9.25 6H10.75ZM10.75 6.01H12.25V6H10.75H9.25V6.01H10.75ZM10 6.76V8.26C11.2426 8.26 12.25 7.25264 12.25 6.01H10.75H9.25C9.25 5.59579 9.58579 5.26 10 5.26V6.76ZM9.25 6.01H7.75C7.75 7.25264 8.75736 8.26 10 8.26V6.76V5.26C10.4142 5.26 10.75 5.59579 10.75 6.01H9.25ZM9.25 6H7.75V6.01H9.25H10.75V6H9.25ZM10 5.25V3.75C8.75736 3.75 7.75 4.75736 7.75 6H9.25H10.75C10.75 6.41421 10.4142 6.75 10 6.75V5.25ZM18.5 10H17C17 13.866 13.866 17 10 17V18.5V20C15.5228 20 20 15.5228 20 10H18.5ZM10 1.5V3C13.866 3 17 6.13401 17 10H18.5H20C20 4.47715 15.5228 0 10 0V1.5ZM1.5 10H3C3 6.13401 6.13401 3 10 3V1.5V0C4.47715 0 0 4.47715 0 10H1.5ZM10 18.5V17C6.13401 17 3 13.866 3 10H1.5H0C0 15.5228 4.47715 20 10 20V18.5ZM10 20V21.5C16.3513 21.5 21.5 16.3513 21.5 10H20H18.5C18.5 14.6944 14.6944 18.5 10 18.5V20ZM0 10H-1.5C-1.5 16.3513 3.64873 21.5 10 21.5V20V18.5C5.30558 18.5 1.5 14.6944 1.5 10H0ZM10 0V-1.5C3.64873 -1.5 -1.5 3.64873 -1.5 10H0H1.5C1.5 5.30558 5.30558 1.5 10 1.5V0ZM20 10H21.5C21.5 3.64873 16.3513 -1.5 10 -1.5V0V1.5C14.6944 1.5 18.5 5.30558 18.5 10H20Z" fill="#fff" mask="url(#path-1-inside-1_4445_41123)"/>\n  </g>\n  <defs>\n    <clipPath id="clip0_4445_41123">\n      <rect width="20" height="20" fill="white"/>\n    </clipPath>\n  </defs>\n</svg>\n  </span>\n  <p class="removed_item_text">Item removed</p>\n  <button class="undo_btn_removed_item" data-id="${e}" data-quantity="${t}">Undo</button>\n  <button class="close_remove_notification">\n  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">\n  <g clip-path="url(#clip0_3453_76214)">\n    <path d="M13.4701 1.47206C13.7305 1.21171 13.7305 0.789596 13.4701 0.529247C13.2098 0.268897 12.7876 0.268897 12.5273 0.529247L6.9987 6.05784L1.4701 0.529247C1.20975 0.268897 0.787644 0.268897 0.527294 0.529247C0.266945 0.789596 0.266945 1.21171 0.527294 1.47206L6.05589 7.00065L0.527293 12.5292C0.266944 12.7896 0.266944 13.2117 0.527293 13.4721C0.787644 13.7324 1.20975 13.7324 1.4701 13.4721L6.9987 7.94346L12.5273 13.4721C12.7876 13.7324 13.2098 13.7324 13.4701 13.4721C13.7305 13.2117 13.7305 12.7896 13.4701 12.5292L7.94151 7.00065L13.4701 1.47206Z" fill="#FBFBF9"/>\n  </g>\n  <defs>\n    <clipPath id="clip0_3453_76214">\n      <rect width="13.3333" height="13.3333" fill="white" transform="translate(0.332031 0.333984)"/>\n    </clipPath>\n  </defs>\n</svg>\n  </button>\n</div>\n    `,
          n = document.createElement("div");
        n.innerHTML = i;
        const s = n.firstElementChild;
        document.body.appendChild(s),
          setTimeout(() => {
            s.remove();
          }, 5e3);
      }),
      document.addEventListener("click", function (e) {
        if (
          ((e.target.matches(".close_remove_notification") ||
            e.target.closest(".close_remove_notification")) &&
            e.target.closest(".cart-item-remove-notify")?.remove(),
          e.target.matches(".undo_btn_removed_item") ||
            e.target.closest(".undo_btn_removed_item"))
        ) {
          const t = e.target.matches(".undo_btn_removed_item")
            ? e.target
            : e.target.closest(".undo_btn_removed_item");
          t.closest(".cart-item-remove-notify")?.remove();
          const i = t.dataset.id,
            n = t.dataset.quantity;
          theme.addToCartItem(i, n);
        }
      }),
      (theme.addToCartItem = function (e, t) {
        const i = JSON.stringify({ id: e, quantity: t });
        fetch(`${theme.routes.cartAdd}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/javascript",
          },
          body: i,
        })
          .then((e) => e.text())
          .then((e) => {
            JSON.parse(e);
            const t = document.querySelector("cart-form");
            t && t.enableAjaxUpdate && t.refresh();
          });
      }),
      document.querySelectorAll(".limited_textarea")?.forEach((e) => {
        e.addEventListener("input", function () {
          const e = this.closest("div"),
            t = e?.querySelector(".character_count"),
            i = this.getAttribute("maxlength"),
            n = this.value.length;
          t && i && (t.textContent = `${n}/${i}`);
        });
      });
    const t = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          e.isIntersecting &&
            (!(function (e) {
              theme.manuallyLoadImages(e.target);
            })(e),
            t.unobserve(e.target));
        });
      },
      { root: null, threshold: 0.2 }
    );
    document.querySelectorAll(".container").forEach((e) => {
      t.observe(e);
    });
  });
class VRMediaBlock extends HTMLElement {
  constructor() {
    super(),
      this.attachShadow({ mode: "open" }),
      (this.frames = []),
      (this.currentFrame = 0),
      (this.loaded = !1),
      (this.allFramesLoaded = !1),
      (this.jsonUrl = this.dataset.jsonUrl),
      (this.loadingIcon = this.dataset.loadingIcon || "loading.gif"),
      (this.shadowRoot.innerHTML =
        '\n            <style>\n                :host {\n                    display: block;\n                    position: relative;\n                    width: 100%;\n                    height: 100%;\n                    background: #f9f9f9;\n                }\n                canvas {\n                    width: 100%;\n                    height: 100%;\n                    display: block;\n                    position: absolute;\n                    z-index: 1;\n                    top: 0;\n                    left: 0;\n                    object-fit: contain;\n                    background: #eee;\n                    cursor: grab;\n                    opacity: 1;\n                    transition: opacity 0.3s ease;\n                }\n                canvas.loading {\n                    opacity: 0.3;\n                }\n                .vr-slider-container {\n                    display: none;\n                    position: absolute;\n                    bottom: 10px;\n                    left: 20px;\n                    right: 20px;\n                    height: 1px;\n                    background: #ccc;\n                    border-radius: 3px;\n                    z-index: 2;\n                    opacity: 0;\n                    transition: opacity 0.3s ease;\n                }\n                .vr-slider-container.visible {\n                    opacity: 1;\n                }\n                .vr-slider-thumb {\n                    position: absolute;\n                    top: -5px;\n                    width: 40px;\n                    height: 11px;\n                    background: #43d5b0;\n                    border-radius: 10px;\n                    cursor: pointer;\n                    transition: all 0.1s ease;\n                }\n                .vr-button {\n                    position: absolute;\n                    bottom: 0;\n                    left: 50%;\n                    transform: translateX(-50%);\n                    background: transparent; \n                    padding: 8px 14px;\n                    border-radius: 4px;\n                    cursor: pointer;\n                    font-size: 14px;\n                    z-index: 2;\n                    transition: opacity 0.3s ease;\n                }\n                .vr-button:hover {\n                    opacity: 0.7;\n                }\n                .loading-overlay {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100%;\n                    height: 100%;\n                    background: rgba(255,255,255,0.9);\n                    display: none;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    z-index: 3;\n                    opacity: 0;\n                    transition: opacity 0.3s ease;\n                }\n                .loading-overlay.visible {\n                    opacity: 1;\n                    display: flex;\n                }\n                .moving span.vr-slider-thumb {\n                    background: #000;\n                    border-radius: 50%;\n                }\n                .loader-vr-media {\n                    width: 48px;\n                    height: 48px;\n                    border: 5px solid #000;\n                    border-bottom-color: transparent;\n                    border-radius: 50%;\n                    display: inline-block;\n                    box-sizing: border-box;\n                    animation: rotation-vr-media 1s linear infinite;\n                    margin-bottom: 16px;\n                }\n                .loading-text {\n                    font-size: 14px;\n                    color: #666;\n                    margin-bottom: 8px;\n                }\n                .loading-progress {\n                    width: 200px;\n                    height: 4px;\n                    background: #eee;\n                    border-radius: 2px;\n                    overflow: hidden;\n                }\n                .loading-progress-bar {\n                    height: 100%;\n                    background: #43d5b0;\n                    border-radius: 2px;\n                    transition: width 0.3s ease;\n                    width: 0%;\n                }\n                @keyframes rotation-vr-media {\n                    0% { transform: rotate(0deg); }\n                    100% { transform: rotate(360deg); }\n                }\n            </style>\n            <canvas></canvas>\n            <div class="vr-slider-container">\n                <span class="vr-slider-thumb"></span>\n            </div>\n            <div class="vr-button">\n                <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 200 200">\n                    <defs><style>.cls-1 { fill-rule: evenodd;}</style></defs>\n                  <path id="Shape_1_copy_2" data-name="Shape 1 copy 2" class="cls-1" d="M100,166a65.768,65.768,0,0,1-47.565-20.288l0.061,11.2-7.23-7.23-0.092-16.956,16.955,0.093,7.23,7.23-11.647-.063a57.649,57.649,0,0,0,92.509-67.2l9.93,0.054A65.994,65.994,0,0,1,100,166Zm23.007-83.4a12.429,12.429,0,0,1,5.268-1.119,12.6,12.6,0,0,1,5.293,1.119,11.393,11.393,0,0,1,4.25,3.407,16.945,16.945,0,0,1,2.816,5.783,29.762,29.762,0,0,1,1.018,8.273,29.8,29.8,0,0,1-1.018,8.261,16.942,16.942,0,0,1-2.816,5.8,11.393,11.393,0,0,1-4.25,3.407,12.594,12.594,0,0,1-5.293,1.119,12.425,12.425,0,0,1-5.268-1.119,11.341,11.341,0,0,1-4.212-3.407,16.9,16.9,0,0,1-2.791-5.8A30.131,30.131,0,0,1,115,100.068,30.1,30.1,0,0,1,116,91.8a16.9,16.9,0,0,1,2.791-5.783A11.341,11.341,0,0,1,123.007,82.6Zm-1.031,24a13.168,13.168,0,0,0,1.521,4.124,5.592,5.592,0,0,0,2.2,2.15,5.734,5.734,0,0,0,2.577.616,5.869,5.869,0,0,0,2.615-.616,5.648,5.648,0,0,0,2.226-2.15,13.165,13.165,0,0,0,1.546-4.124,30.779,30.779,0,0,0,.578-6.538,30.784,30.784,0,0,0-.578-6.538,13.178,13.178,0,0,0-1.546-4.124,5.651,5.651,0,0,0-2.226-2.15,5.875,5.875,0,0,0-2.615-.616,5.739,5.739,0,0,0-2.577.616,5.6,5.6,0,0,0-2.2,2.15,13.18,13.18,0,0,0-1.521,4.124,31.417,31.417,0,0,0-.566,6.538A31.412,31.412,0,0,0,121.976,106.606ZM101.42,95.542a12.106,12.106,0,0,1,4.011.679,9.707,9.707,0,0,1,3.432,2.049,10.211,10.211,0,0,1,2.389,3.408,11.6,11.6,0,0,1,.905,4.752,12.23,12.23,0,0,1-.93,4.765,11.752,11.752,0,0,1-2.615,3.885,12.177,12.177,0,0,1-4.061,2.615,15,15,0,0,1-10.473.025,11.368,11.368,0,0,1-3.948-2.6,11.237,11.237,0,0,1-2.5-4.023,14.979,14.979,0,0,1-.868-5.218,14.575,14.575,0,0,1,1.044-5.268,23.761,23.761,0,0,1,3.231-5.62l8.675-11.642a3.59,3.59,0,0,1,1.321-1.031,4.465,4.465,0,0,1,2-.428h5.532L97.774,95.09q-0.353.428-.666,0.8t-0.616.779A10.8,10.8,0,0,1,101.42,95.542Zm-6.9,6.55a6.134,6.134,0,0,0-1.333,2.113,7.3,7.3,0,0,0-.465,2.627,8.672,8.672,0,0,0,.415,2.754,5.745,5.745,0,0,0,1.232,2.125,5.58,5.58,0,0,0,2.024,1.37,7.373,7.373,0,0,0,2.791.49,7.207,7.207,0,0,0,2.729-.5,6.243,6.243,0,0,0,2.137-1.408,6.552,6.552,0,0,0,1.4-2.124,6.9,6.9,0,0,0,.5-2.653,7.786,7.786,0,0,0-.478-2.8,5.876,5.876,0,0,0-1.358-2.112,5.813,5.813,0,0,0-2.112-1.32,7.821,7.821,0,0,0-2.716-.453,6.937,6.937,0,0,0-2.691.5A6.169,6.169,0,0,0,94.518,102.092Zm-13.314.063a8.5,8.5,0,0,1,1.609,5.306,10.938,10.938,0,0,1-1.006,4.8,10.327,10.327,0,0,1-2.716,3.508,11.839,11.839,0,0,1-3.96,2.15,15.369,15.369,0,0,1-4.765.729,16.262,16.262,0,0,1-4.778-.629,10.362,10.362,0,0,1-3.546-1.861,11.231,11.231,0,0,1-2.565-3.017,20.358,20.358,0,0,1-1.81-4.124l2.741-1.131a3.591,3.591,0,0,1,1.433-.3,2.439,2.439,0,0,1,1.169.276,1.89,1.89,0,0,1,.792.805q0.453,0.88.993,1.735a7.027,7.027,0,0,0,1.3,1.521,6.157,6.157,0,0,0,1.773,1.082,6.428,6.428,0,0,0,2.426.415,6.867,6.867,0,0,0,2.766-.516,6,6,0,0,0,1.974-1.345,5.526,5.526,0,0,0,1.182-1.848,5.7,5.7,0,0,0,.39-2.05,9.494,9.494,0,0,0-.277-2.376,3.526,3.526,0,0,0-1.157-1.823,6.285,6.285,0,0,0-2.527-1.182,18.23,18.23,0,0,0-4.413-.427V97.4a15.032,15.032,0,0,0,3.8-.4,6.463,6.463,0,0,0,2.4-1.119,3.8,3.8,0,0,0,1.245-1.723,6.663,6.663,0,0,0,.352-2.213,5.107,5.107,0,0,0-1.408-3.91,5.4,5.4,0,0,0-3.847-1.32A5.686,5.686,0,0,0,67.1,87.884a6.106,6.106,0,0,0-2.037,3,2.736,2.736,0,0,1-.83,1.369,2.177,2.177,0,0,1-1.383.414,5.291,5.291,0,0,1-.855-0.074l-3.269-.569a13.491,13.491,0,0,1,1.458-4.59,11.006,11.006,0,0,1,2.7-3.3,11.2,11.2,0,0,1,3.722-1.987,14.835,14.835,0,0,1,4.514-.667,13.537,13.537,0,0,1,4.539.717,10.366,10.366,0,0,1,3.458,1.987,8.707,8.707,0,0,1,2.2,2.98,8.931,8.931,0,0,1,.767,3.7,10.824,10.824,0,0,1-.39,3.055,7.122,7.122,0,0,1-1.132,2.3,6.863,6.863,0,0,1-1.811,1.66,10.989,10.989,0,0,1-2.427,1.132A9.5,9.5,0,0,1,81.2,102.155Zm49.438-41.406,10.848,0.059A57.648,57.648,0,0,0,48.982,128l-8.772-.048a65.98,65.98,0,0,1,107.35-73.672l-0.056-10.4,7.23,7.23,0.092,16.956-16.955-.093Z"/>\n                </svg>\n            </div>\n            <div class="loading-overlay">\n                <span class="loader-vr-media"></span>\n                <div class="loading-text">Loading VR content...</div>\n                <div class="loading-progress">\n                    <div class="loading-progress-bar"></div>\n                </div>\n            </div>\n        '),
      (this.canvas = this.shadowRoot.querySelector("canvas")),
      (this.ctx = this.canvas.getContext("2d")),
      (this.slider = this.shadowRoot.querySelector(".vr-slider-container")),
      (this.thumb = this.shadowRoot.querySelector(".vr-slider-thumb")),
      (this.button = this.shadowRoot.querySelector(".vr-button")),
      (this.loadingOverlay = this.shadowRoot.querySelector(".loading-overlay")),
      (this.loadingProgressBar = this.shadowRoot.querySelector(
        ".loading-progress-bar"
      )),
      (this.loadingText = this.shadowRoot.querySelector(".loading-text"));
  }
  connectedCallback() {
    const e = this.dataset.placeholder;
    if (e) {
      const t = new Image();
      (t.onload = () => {
        (this.canvas.width = t.width),
          (this.canvas.height = t.height),
          this.drawImageFit(t);
      }),
        (t.src = e);
    }
    this.button.addEventListener("click", () => {
      this.loaded ||
        (this.startLoading(),
        this.loadJSON(this.jsonUrl)
          .then(() => {
            (this.loaded = !0), this.finishLoading();
          })
          .catch((e) => {
            this.handleLoadingError(e);
          }));
    });
  }
  startLoading() {
    this.loadingOverlay.classList.add("visible"),
      this.canvas.classList.add("loading"),
      (this.button.style.opacity = "0.3"),
      (this.button.style.pointerEvents = "none");
  }
  updateLoadingProgress(e, t, i = "") {
    const n = (e / t) * 100;
    this.loadingProgressBar.style.width = `${n}%`;
    let s = `Loading frames... ${e}/${t}`;
    i && (s += ` (${i})`), (this.loadingText.textContent = s);
  }
  finishLoading() {
    setTimeout(() => {
      this.loadingOverlay.classList.remove("visible"),
        this.canvas.classList.remove("loading"),
        (this.button.style.display = "none"),
        (this.slider.style.display = "block"),
        setTimeout(() => {
          this.autoRotateOnce(() => {
            this.slider.classList.add("visible"),
              this.initSlider(),
              this.initCanvasDrag();
          });
        }, 100);
    }, 200);
  }
  handleLoadingError(e) {
    console.error("Failed to load VR content:", e),
      (this.loadingText.textContent = "Loading failed. Click to retry"),
      (this.loadingProgressBar.style.background = "#ff4444"),
      (this.button.style.opacity = "1"),
      (this.button.style.pointerEvents = "auto"),
      (this.loaded = !1),
      (this.allFramesLoaded = !1),
      setTimeout(() => {
        this.loadingOverlay.classList.remove("visible"),
          this.canvas.classList.remove("loading"),
          (this.loadingProgressBar.style.background = "#43d5b0");
      }, 3e3);
  }
  async loadJSON(e) {
    try {
      const t = await fetch(e);
      if (!t.ok) throw new Error(`HTTP ${t.status}: ${t.statusText}`);
      const i = await t.json();
      if (!i.items || !Array.isArray(i.items) || 0 === i.items.length)
        throw new Error("Invalid JSON format: missing or empty items array");
      (this.totalFrames = i.items.length),
        (this.frames = new Array(this.totalFrames));
      let n = 0,
        s = 0;
      this.updateLoadingProgress(0, this.totalFrames);
      const r = i.items.map((e, t) =>
        this.loadImageWithRetry(e, t, 3).then((i) => {
          i
            ? ((this.frames[t] = i),
              n++,
              this.updateLoadingProgress(n, this.totalFrames),
              1 === n &&
                ((this.canvas.width = i.width),
                (this.canvas.height = i.height),
                this.drawFrame(t)))
            : (s++,
              console.warn(
                `Failed to load frame ${t} after retries: ${e.src}`
              ));
        })
      );
      await Promise.all(r);
      const o = n / this.totalFrames;
      if (o < 0.5)
        throw new Error(
          `Too many failed frames: ${s}/${
            this.totalFrames
          } failed. Success rate: ${Math.round(100 * o)}%`
        );
      s > 0 &&
        (console.warn(
          `${s} frames failed to load, but continuing with ${n} frames`
        ),
        this.fillMissingFrames()),
        (this.allFramesLoaded = !0),
        this.updateLoadingProgress(this.totalFrames, this.totalFrames);
    } catch (e) {
      throw new Error(`Failed to load VR content: ${e.message}`);
    }
  }
  async loadImageWithRetry(e, t, i = 3) {
    if (!e.src) return console.warn(`Item ${t} missing src property`), null;
    for (let n = 1; n <= i; n++)
      try {
        return await this.loadSingleImage(e.src, t, n);
      } catch (e) {
        if (
          (console.warn(`Attempt ${n}/${i} failed for image ${t}:`, e.message),
          n < i)
        ) {
          const e = Math.min(1e3 * Math.pow(2, n - 1), 3e3);
          await new Promise((t) => setTimeout(t, e));
        }
      }
    return null;
  }
  loadSingleImage(e, t, i) {
    return new Promise((n, s) => {
      const r = new Image();
      r.crossOrigin = "anonymous";
      const o = 1 === i ? 15e3 : 8e3,
        a = setTimeout(() => {
          s(new Error(`Timeout (${o}ms) loading image ${t}, attempt ${i}`));
        }, o);
      (r.onload = () => {
        clearTimeout(a), n(r);
      }),
        (r.onerror = () => {
          clearTimeout(a),
            s(new Error(`Network error loading image ${t}, attempt ${i}`));
        });
      const l = i > 1 ? `?retry=${i}&t=${Date.now()}` : "";
      r.src = e + l;
    });
  }
  fillMissingFrames() {
    for (let e = 0; e < this.totalFrames; e++)
      if (!this.frames[e]) {
        let t = null;
        for (let i = e + 1; i < this.totalFrames; i++)
          if (this.frames[i]) {
            t = this.frames[i];
            break;
          }
        if (!t)
          for (let i = e - 1; i >= 0; i--)
            if (this.frames[i]) {
              t = this.frames[i];
              break;
            }
        t && (this.frames[e] = t);
      }
  }
  drawFrame(e) {
    !this.frames[e] ||
      e < 0 ||
      e >= this.totalFrames ||
      ((this.currentFrame = e),
      this.drawImageFit(this.frames[e]),
      this.updateThumbPosition());
  }
  drawImageFit(e) {
    if (!e || !e.complete) return;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    const t = Math.max(
        this.canvas.width / e.width,
        this.canvas.height / e.height
      ),
      i = e.width * t,
      n = e.height * t,
      s = (this.canvas.width - i) / 2,
      r = (this.canvas.height - n) / 2;
    this.ctx.drawImage(e, s, r, i, n);
  }
  updateThumbPosition() {
    if (!this.slider.offsetWidth || this.totalFrames <= 1) return;
    const e = this.slider.offsetWidth,
      t = e / (this.totalFrames - 1),
      i = Math.max(0, Math.min(e - 20, this.currentFrame * t - 20));
    this.thumb.style.left = i - 12 + "px";
  }
  autoRotateOnce(e) {
    if (!this.allFramesLoaded) return void (e && e());
    let t = 0;
    const i = 2e3 / this.totalFrames,
      n = setInterval(() => {
        t < this.totalFrames && this.frames[t]
          ? (this.drawFrame(t), t++)
          : (clearInterval(n), this.drawFrame(0), e && e());
      }, i);
  }
  initSlider() {
    const e = (e) => {
      if (!this.allFramesLoaded) return;
      this.slider.classList.add("moving");
      const t = this.slider.getBoundingClientRect(),
        i = Math.max(0, Math.min(t.width, e - t.left)),
        n = t.width / (this.totalFrames - 1);
      let s = Math.round(i / n);
      (s = Math.max(0, Math.min(this.totalFrames - 1, s))), this.drawFrame(s);
    };
    this.thumb.addEventListener("mousedown", (t) => {
      t.preventDefault();
      const i = (t) => e(t.clientX),
        n = () => {
          window.removeEventListener("mousemove", i),
            window.removeEventListener("mouseup", n),
            this.slider.classList.remove("moving");
        };
      window.addEventListener("mousemove", i),
        window.addEventListener("mouseup", n);
    }),
      this.thumb.addEventListener("touchstart", (t) => {
        t.preventDefault();
        const i = (t) => {
            t.preventDefault(), e(t.touches[0].clientX);
          },
          n = () => {
            window.removeEventListener("touchmove", i),
              window.removeEventListener("touchend", n),
              this.slider.classList.remove("moving");
          };
        window.addEventListener("touchmove", i, { passive: !1 }),
          window.addEventListener("touchend", n);
      });
  }
  initCanvasDrag() {
    let e = !1,
      t = 0,
      i = 0;
    const n = (i) => {
        this.allFramesLoaded &&
          ((e = !0), (t = i), (this.canvas.style.cursor = "grabbing"));
      },
      s = (n) => {
        if (!e || !this.allFramesLoaded) return;
        const s = Date.now();
        if (s - i < 16) return;
        i = s;
        const r = n - t;
        if (Math.abs(r) >= 3) {
          const e = r > 0 ? 1 : -1;
          (this.currentFrame =
            (this.currentFrame + e + this.totalFrames) % this.totalFrames),
            this.drawFrame(this.currentFrame),
            (t = n);
        }
      },
      r = () => {
        (e = !1), (this.canvas.style.cursor = "grab");
      };
    this.canvas.addEventListener("mousedown", (e) => {
      e.preventDefault(), n(e.clientX);
    }),
      this.canvas.addEventListener("mousemove", (e) => s(e.clientX)),
      this.canvas.addEventListener("mouseup", r),
      this.canvas.addEventListener("mouseleave", r),
      this.canvas.addEventListener(
        "touchstart",
        (e) => {
          e.preventDefault(), n(e.touches[0].clientX);
        },
        { passive: !1 }
      ),
      this.canvas.addEventListener(
        "touchmove",
        (e) => {
          e.preventDefault(), s(e.touches[0].clientX);
        },
        { passive: !1 }
      ),
      this.canvas.addEventListener(
        "touchend",
        (e) => {
          e.preventDefault(), r();
        },
        { passive: !1 }
      ),
      this.canvas.addEventListener("touchcancel", r);
  }
}
customElements.define("vr-media-block", VRMediaBlock);

  class MetaColorCount extends HTMLElement {
    connectedCallback() {
      const productId = this.getAttribute('id');
      const count = window.group_products?.[productId];

      if (count && count - 1 > 0) {
        const countElement = this.querySelector('.swatches_count');
        if (countElement) {
          countElement.textContent = `+ ${count - 1} Colors`;
        }
      }
    }
  }

  // Define custom element
  if (!customElements.get('meta-color-count')) {
    customElements.define('meta-color-count', MetaColorCount);
  }

 
